// author gurusha : 01/24/2018
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import ApplyCSS from '../../../../components/ApplyCSS';
import Tabs from '../../../../components/ZUILib/Tabs';
import GiftListHeaderWap from './wapComponents/GiftListHeaderWap';
import PersonalPurchasesWap from './wapComponents/ComprasPersonalesWAP';
import RegisteredGiftsWap from './wapComponents/RegistradosContent';
import ReceivedGiftsWeb from './components/RegalosRecibidosContent';
import ReceivedGiftsWap from './wapComponents/RecibidosContent';
import RegisteredGiftsWeb from './components/RegalosRegistradosContent';
import PersonalPurchasesWeb from './components/ComprasPersonales';
import GiftListSummary from './components/GiftListSummary';
import GiftListHeader from './components/GiftListHeader';
import ProductDetails from './wapComponents/ComprasPersonalesWAP/productDetails';
import ProductDetailsRecibidos from './wapComponents/RecibidosContent/productDetails';
import InputButton from './../../../../components/ZUILib/InputButton';
import Link from '../../../../components/ZUILib/Link';
import SuspendedEventBanner from './components/SuspendedEventBanner';
import BrandSelectionModal from '../GiftList/components/BrandSelectionModal';
import * as labelsActions from '../../../../components/labels/actions';
import * as giftListActions from './actions';
import commonUtil from '../../../../utils/commonUtil';
import serverClientUtil from '../../../../utils/serverClientUtil';
import * as defaultConst from '../../../../utils/clientConstant';
import { setPageFlag } from '../../../createEvent/components/ContractPage/actions';
import AppEvents from '../../../App/AppEvents';
import Tagging from '../../../../components/Tagging';
import Transition from '../../../../components/Transition';
import VozCliente from '../../../../components/VozCliente';
import _ from 'lodash';
import PaginationIndicator from './components/PaginationIndicator';
import ModalPopover from '../../../../components/ZUILib/ModalPopover';
import { ShareButton, FacebookProvider } from 'react-facebook';
// import EventCreationThanksModalWap from './wapComponents/EventCreationThanksModalWap';
import GiftListSidebar from './components/GiftListSidebar';
import PersonalData from './components/PersonalData';
import PersonalDataWap from './wapComponents/PersonalDataWap';
import GiftListConfigureWap from './wapComponents/GiftListConfigureWap';
import DeliveryAddress from '../EventData/DeliveryAddress';
import Personalization from './components/Personalization';
import ContractEM from './components/Contract/index';
import CreateTableModalOverlay from './components/CreateTable/components/createTableModalOverlay';
import EventGiftModalOverlay from './components/EventGift/components/EventGiftModalOverlay';
import GiftRegistryIdModalOverlay from './components/EventGift/components/giftRegistryIdModalOverlay';
import homeicon  from '../../../../../assets/web/images/icons/giftlist/home.svg';
import article from '../../../../../assets/web/images/icons/giftlist/article.svg';
import gift from '../../../../../assets/web/images/icons/giftlist/gift.svg';
import person from '../../../../../assets/web/images/icons/giftlist/person.svg';
import personalization from '../../../../../assets/web/images/icons/giftlist/personalization.svg';
import localShipping from '../../../../../assets/web/images/icons/giftlist/local_shipping.svg';
import add from '../../../../../assets/web/images/icons/giftlist/add_circle.svg';
import barcode from '../../../../../assets/web/images/icons/giftlist/barcode.svg';

import * as EventCategoryActions from "../../../../components/eventcategory/actions";
import { updateGiftListHeader } from "../../../../components/globleObject/actions"
const { isEventCategoryLoaded, loadEventCategoryEvent } = EventCategoryActions;

import { getDeliveryAddressInfo } from '../../../eventManagement/page/EventData/DeliveryAddress/actions';

import TextInput from '../../../../components/ZUILib/TextInput';
import EventCardProfile from '../../../../components/EventTemplate/EventCardProfile';
import GiftListCategories from './components/GiftListContent/GiftListCategories';
import Template2 from './components/RegalosRegistradosContent/template2';
import DownloadPDFWithoutPreview from '../../../../components/DownloadPDFWithoutPreview';
import DownloadPDFWithoutPreviewMsg from '../../../../components/DownloadPDFWithoutPreview/message';
import pdfUtil from '../../../../utils/PDFUtil';
import RadioButton from '../../../../components/ZUILib/RadioButton';
import Accordion from './components/Accordion';

import { handleGetEventCardDetails } from '../EventData/CelebratedCard/actions';
import Warning2 from '../../../../components/Warning2';

import { isAllowedEventTypesLoaded, loadAllowedEventTypes } from "../../../BrowseAndNavigate/AllowedEventTypes/action";
import MarketingContentSection from '../../../BrowseAndNavigate/MarketingContentSection';
import ChatMessageWap from './components/RegalosRecibidosContent/components/ChatMessageWap';
import MessagesTemplate from './components/RegalosRecibidosContent/components/MessagesTemplate';

import * as accountStatusDetailsAction from '../../../BrowseAndNavigate/AccountSummary/actions';

import { setGiftListTransferenceStatementTab } from './actions';
import AddGiftsButton from './components/GiftListContent/AddGiftsButton';

// import RegalosRegistrados from './components/RegalosRegistrados';

const applicationRoutes = commonUtil.getApplicationRoutes();

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const { isLablesLoaded, loadLables } = labelsActions;
const { getReceivedGiftList, getRegisteredGiftList, getPersonalShoppingList, getEventSummaryInfo, setNotificationCount, getEventDetails, getEventThresholdGiftDetails, getGiftlistMarketingContent, getGiftlistFooterMarketingContent, getPurchaseInfoDetails, resetStore } = giftListActions;

const { getEventAccountStatementDetails, getInTransitDetails, getStatementDetailsForPrintAndDownload } = accountStatusDetailsAction;

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isEventCategoryLoaded(getState())) {
      return dispatch(loadEventCategoryEvent());
    }
    return undefined;
  },
},
{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isAllowedEventTypesLoaded(getState())) {
      return dispatch(loadAllowedEventTypes());
    }
    return undefined;
  },
},
])

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  user: store.user.data,
  extraData: store.labels.extraData,
  giftList : store.giftList.data,
  eventCategory: store.eventcategory.data,
  allowedEventTypes: store.allowedEventTypes.data,
  globalObject: store.globleObject,
  isTransferenceStatementTab: store.giftList.isTransferenceStatementTab,
  cscAdminProfile: store?.cscAdminProfile?.data,
}),
  {
    ...labelsActions,
    ...giftListActions,
    updateGiftListHeader,
    setGiftListTransferenceStatementTab,
  })

class GiftList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suspendedData: null,
      allowUpdate: true,
      displaySelectedProductDetail: null,
      giftSectionType: null,
      sortingValue: '',
      filterParam: [],
      selectedTab: { registered: true, recieved: false, personal: false },
      selectedTabIndex: 0,
      shareModal: { web: null, wap: null },
      activeBar: props?.location?.state?.activeSection || 'mesa-de-regalos',
      isactiveItem: 1, // Default active item in Event Managenent Modal
      selectedTheme : {},
      eventIcon: {},
      activeCategory: null,
      activeCategoryReceivedGift: null,
      activeCategoryPersonalShoppingList: null,
      activeThemeColor: '',
      categoryDepartmentId: [],
      filterParamsReceivedGift: [],
      filterParamsPersonalShoppingList: [],
      regalosModalWap: false,
      chatMessageModalWap: false,
      displayRegalosSelectedProductDetailWap: null,
      isMessageSectionDropDownWapOpen: false,
      giftSectionTypeWap: null,
      receivedGiftsSortingValue: '',
      personalPurchasesSortingValue: '',
      addAgainAlert: false,
      shouldDownloadPdf: false,
    };
    this.eventId = (this.props.params && this.props.params.eventID) ? this.props.params.eventID : '';
    this.tabName = (this.props.location && this.props.location.state && this.props.location.state.tabName) ? this.props.location.state.tabName : '';
    this.profileId = (this.props.user && this.props.user.result && this.props.user.result.profileId) ? this.props.user.result.profileId : '';
    this.eventInfo = '';
    this.sorting = [];
    this.pageArray = [];
    this.personalItemsInfo = [];
    this.receivedItemsInfo = [];
    this.registeredItemsInfo = [];
    this.allRegisteredItemsInfo = [];
    this.currentPage = 1;
    this.totalRecords = 0;
    this.loadedRecordCount = 0;
    this.type = '';
    this.typeToParams = {};
    this.filteringParameters = [];
    this.totalRegisteredGiftsCount = 0;
    // this.getEventTokenEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.GET_EVENT_TOKEN);
    this.wapBackButtonEvent = null;
    this.changeViewOnBackButtonClick = false;
    this.changeComponentOnBackButtonClick = this.changeComponentOnBackButtonClick.bind(this);
    this.summaryInfoResponse = '';
    this.suspendedData = '';
    this.bannerData = '';
    this.selectedTabIndex = 0;
    this.selectedTab = 'registered';
    this.tabFlag = '';
    this.flag = false;
    this.recibidosCategory = null;
    this.comprasCategory = null;
    this.receivedGiftsWapRef = React.createRef();
    this.defaultTheme = {
      "color_50": "#E9EBF8",
      "color_100": "#C0C0C0",
      "color_200": "#A1A1A1",
      "color_300": "#767676",
      "color_400": "#5C5C5C",
      "color_500": "#333333",
      "color_600": "#2E2E2E",
      "color_700": "#242424",
      "color_800": "#1C1C1C",
      "color_900": "#151515",
    };

    this.eventStatusBox = this.eventStatusBox.bind(this);
    this.anadirRegalosDivEnable = this.anadirRegalosDivEnable.bind(this);

    if (props.isTransferenceStatementTab || props.location?.query?.tab === 'summary') {
      this.selectedTab = 'summary';
      this.selectedTabIndex = 3;
      this.state.selectedTabIndex = 3;
      this.state.selectedTab = { registered: false, recieved: false, personal: false, summary: true };
    } else {
      this.selectedTab = this.selectedTab || 'registered';
    }
  }

    handleConfigure = (e) => {
        e.preventDefault();
        this.setState({ showModal: true });
    }

  selectedProductForPreview = (product, giftType) => {
    commonUtil.goToTop();
    this.changeViewOnBackButtonClick = true;
    this.setState({ displaySelectedProductDetail: product, giftSectionType: giftType });
  }
  sortingTypeForFilter = (sortingType) => {
    this.setState({ sortingValue: sortingType });
  }
  selectedFilteringParameters = (filterParams) => {
    this.setState({ filterParam: filterParams });
  }
  filteringParameters = []

  setTotalRecordsForType = (type, count, loadedRecordCount, sortType, currentPage) => {
    const params = {};
    params.totalRecords = count;
    params.sortType = sortType;
    params.loadedRecordCount = loadedRecordCount;
    params.currentPage = currentPage;
    this.typeToParams[type] = params;
  }
  infiniteScrollCondition = (props) => {
    const currentTab = document.querySelector('.active a');
    if (!currentTab) return false;
    const activeTabId = document.querySelector('.active a').id;
    const selectedParams = this.typeToParams[activeTabId];
    if (!selectedParams) return false;
    const totalRecords = selectedParams.totalRecords;
    const loadedRecordCount = selectedParams.loadedRecordCount;
    let loading = true;
    if (this.type === 'tabpersonal') {
      loading = props.loadingPersonalGifts;
    } else if (this.type === 'tabrecieved') {
      loading = props.loadingReceivedGifts;
    } else if (this.type === 'tabregistered') {
      loading = props.loadingRegisteredGifts;
    }
    this.type = activeTabId;
    return ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 500)
      && loadedRecordCount < totalRecords
      && !loading);
  }

  changeAllowUpdate = () => this.setState({ allowUpdate: false })

  getRecievedGiftList = (searchKeyword, sorting, filteringParameters,currentPage) => {
    this.filteringParameters = filteringParameters;
    this.props.getReceivedGiftList(this.eventId, searchKeyword, sorting, filteringParameters,currentPage);
  }

  getRegisteredGiftList = (sorting, searchKeyword, priceOrderCategory) => {
    this.sorting = this.sorting.filter(sort => sort.category !== priceOrderCategory);
    this.sorting.push({
      category: priceOrderCategory,
      sortType: sorting,
    });
    this.props.getRegisteredGiftList(this.eventId, sorting, searchKeyword, priceOrderCategory, '', false, this.state.categoryDepartmentId);
  }

  getPaginatedPersonalPurchases = (requestFields,initialCall) => {
    commonUtil.showApplicationLoader();
    const allowedRequestFields = _.pick(requestFields, [
      'searchKeyword',
      'priceOrder',
      'filteringParameters',
      'currentPage',
    ]);
   /*  const definedRequestFields = _.pickBy(
      allowedRequestFields,
      (value, key) => {
        if (['priceOrder', 'searchKeyword'].includes(key)) return _.isString(value) && !_.isEmpty(value);
        if (key === 'filteringParameters') return _.isArray(value) && !_.isEmpty(value);
        if (key === 'currentPage') return _.isNumber(value) && value > 0;
        return false;
      },
    ); */
    const definedRequestFields = _.pickBy(
      allowedRequestFields,
      requestField => !_.isNil(requestField),
    );
    this.props
      .getPersonalShoppingList(
        this.eventId,
        definedRequestFields.searchKeyword,
        initialCall ? undefined : _.defaultTo(definedRequestFields.priceOrder, 'Ascending'),
        definedRequestFields.filteringParameters,
        _.defaultTo(definedRequestFields.currentPage, 1),
      )
      .then(() => commonUtil.hideApplicationLoader())
      .catch(() => commonUtil.hideApplicationLoader());
  };

  getPaginatedReceivedGifts = (requestFields,initialCall) => {
    commonUtil.showApplicationLoader();
    const allowedRequestFields = _.pick(requestFields, [
      'searchKeyword',
      'priceOrder',
      'filteringParameters',
      'currentPage',
    ]);
    /* const definedRequestFields = _.pickBy(
      allowedRequestFields,
      (value, key) => {
        if (['priceOrder', 'searchKeyword'].includes(key)) return _.isString(value) && !_.isEmpty(value);
        if (key === 'filteringParameters') return _.isArray(value) && !_.isEmpty(value);
        if (key === 'currentPage') return _.isNumber(value) && value > 0;
        return false;
      },
    ); */

    const definedRequestFields = _.pickBy(
      allowedRequestFields,
      requestField => !_.isNil(requestField),
    );
    this.props
      .getReceivedGiftList(
        this.eventId,
        definedRequestFields.searchKeyword,
        initialCall ? undefined : _.defaultTo(definedRequestFields.priceOrder, 'Ascending'),
        definedRequestFields.filteringParameters,
        _.defaultTo(definedRequestFields.currentPage, 1),
      )
      .then(() => commonUtil.hideApplicationLoader())
      .catch(() => commonUtil.hideApplicationLoader());
  };

  getPaginatedRegisteredGifts = (requestFields,getAllItems) => {
    const allowedRequestFields = _.pick(requestFields, [
      'currentPage',
      'searchKeyword',
      'priceOrder',
      'priceOrderCategory',
      'categoryDepartmentId',
    ]);
    const definedRequestFields = _.pickBy(
      allowedRequestFields,
      requestField => !_.isNil(requestField),
    );
    this.props.getRegisteredGiftList(
      this.eventId,
      _.defaultTo(definedRequestFields.priceOrder, 'Ascending'),
      definedRequestFields.searchKeyword,
      _.defaultTo(definedRequestFields.priceOrderCategory, 'default'),
      definedRequestFields.currentPage,
      false,
       _.defaultTo(definedRequestFields.categoryDepartmentId, this.state.categoryDepartmentId),
      getAllItems ? getAllItems : false,
    );
  };

  getPersonalShoppingList = (searchKeyword, sorting, filteringParameters) => {
    this.filteringParameters = filteringParameters;
    this.props.getPersonalShoppingList(this.eventId, searchKeyword, sorting, filteringParameters);
  }
  componentWillUnmount() {
    this.props.resetStore();
    this.props.setPageFlag(false);
    // AppEvents.unsubscribe(this.getEventTokenEvent);
    AppEvents.unsubscribe(this.wapBackButtonEvent);
    this.props.setNotificationCount(0);

    if (document.body.classList.contains('body-no-scroll')) {
      document.body.classList.remove('body-no-scroll');
    }
  }
  // componentWillMount() {
  //   this.props.getEventSummaryInfo(this.eventId, this.props.user.result.profileId, this.props.user.result.emailId).then((response) => {
  //     if (response.status === 'success') {
  //       this.summaryInfoResponse = response;
  //       this.newCount = response.eventInfo.recibidosNewItemCount;
  //       this.getRegisteredGiftList('', '', '');
  //       this.getRecievedGiftList('', 'Ascending', []);
  //       this.getPersonalShoppingList('', 'Ascending', []);
  //     }
  //   }).catch((e) => { console.log(e); });
  // }
  getTaggingData = () => {
    const _dataLayer = {};
    _dataLayer.category = 'Home';
    _dataLayer.dimension8 = 'Home';
    if (this.props.user && this.props.user.result && this.props.user.result.profileId) {
      _dataLayer.userId = this.props.user.result.gtmUserId || this.props.user.result.profileId;
    }
    return _dataLayer;
  } 

  getGiftlistMarketingContent = () => {
    console.log("getGiftlistMarketingContent called");
    const eventType = this.props.giftList?.eventSummaryInfo?.eventInfo?.eventType;
    const eventTypeConfiguration = this.props.eventCategory?.eventConfigurations?.filter(eventConfig => eventConfig.name === eventType);
    const giftlistContentPageId = eventTypeConfiguration?.length > 0 && eventTypeConfiguration[0]?.giftlist_content_id;
    if(giftlistContentPageId) {
      this.props.getGiftlistMarketingContent(giftlistContentPageId);
    }
  }

  getGiftlistFooterMarketingContent = () => {
    console.log("getGiftlistFooterMarketingContent called");
      this.props.getGiftlistFooterMarketingContent("giftlist-footer-section");
  }

  getEventSummaryInfoOnLoad = (initialCall) =>{
    this.props.getEventSummaryInfo(this.eventId, this.props.user.result.profileId, this.props.user.result.emailId).then((response) => {
      if (response && response.status?.status === 'success') {
        this.summaryInfoResponse = response;
        this.props.setNotificationCount(response?.eventInfo?.recibidosNewItemCount || "0");
        this.getPaginatedRegisteredGifts();
        this.getPaginatedReceivedGifts(undefined,initialCall);
        this.getPaginatedPersonalPurchases(undefined,initialCall);
        this.getGiftlistMarketingContent();
        this.getGiftlistFooterMarketingContent();
        this.bannerData = response;
        let eventData = _.find(this.props?.eventCategory?.eventConfigurations,['name',response.eventInfo.eventType])
        let themeData = _.find(eventData?.event_themes,["uid",response.eventInfo.eventTheme])
        let eventIcon =  eventData?.event_icon;
        this.setState({selectedTheme : themeData, eventIcon: eventIcon, activeThemeColor: themeData?.color_500 || "#333"  })
        
      }
    // eslint-disable-next-line no-console
    }).catch((e) => { console.log(e); }); // console required
  }

  componentDidMount() {
    if(this.props.isTransferenceStatementTab) {
      this.props.setGiftListTransferenceStatementTab(false);
      this.getSelectedTabValue('summary');
    }

    const { state = {} } = this.props.location;
    const { activeSection } = state;
    if (activeSection) {
      const tabnameformQuery = activeSection;
      let selectedItem = '';
      if (channel == constChannels.WAP) {
        selectedItem = this.initialJsonWap.giftList.items.find(item => item.tabName === tabnameformQuery);
      }
      else {
        selectedItem = this.initialJson.giftList.items.find(item => item.tabName === tabnameformQuery);
      }
      this.setState({
        activeBar: activeSection,
        isactiveItem: selectedItem.id
      })
    }
    this.getEventSummaryInfoOnLoad(true);
    this.props.getEventDetails(this.eventId, this.props.user.result.profileId);

    // this.props.getEventDetails('560035', '9945536225');  //getEventDetails

    this.props.getEventThresholdGiftDetails(this.eventId);
    this.props.getPurchaseInfoDetails(this.eventId);

    // this.props.getEventThresholdGiftDetails('560035'); //getEventThresholdGiftDetails

    this.props.getDeliveryAddressInfo(this.eventId);

    // this.props.getDeliveryAddressInfo('560035');

    if(channel === constChannels.WAP){
      this.props.handleGetEventCardDetails(this.eventId);
    }

    this.props.getEventAccountStatementDetails(this.eventId);
    this.props.getInTransitDetails(this.eventId);
    this.props.getStatementDetailsForPrintAndDownload(this.eventId);

    // if (this.eventId && this.getEventTokenEvent) {
    //   AppEvents.publish(this.getEventTokenEvent, [this.eventId]);
    // }
    this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);

    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [this.changeComponentOnBackButtonClick]);
    }
    // commonUtil.addTransition();
    const _dataLayer = this.getTaggingData();
    this.tagging.applyGTM('Home', _dataLayer);
    const eventUrl = 'gestiondeeventos/listaderegalos/';

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: eventUrl,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Lista de regalos',
      Site: 'Mesa de Regalos',
      idMesa: this.eventId,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.globalObject?.giftListHeader !== this.props.globalObject?.giftListHeader && this.props.globalObject?.giftListHeader == "Mesa de regalos" && this.state.activeBar !== 'mesa-de-regalos') {
      this.getEventSummaryInfoOnLoad();
      if(channel === constChannels.WAP && prevProps.globalObject?.giftListHeader == "Responder mensaje"){
        this.handleChatBackModalOverlay(true);
      }
      this.setState({
        activeBar : 'mesa-de-regalos'
      })
    }

    const finishedLoading =
      prevProps.loadingAllRegisteredGifts &&
      !this.props.loadingAllRegisteredGifts;
  
    if (this.state.shouldDownloadPdf && finishedLoading) {
      this.setState({ shouldDownloadPdf: false }, () => {
        this.generateAndDownloadPdf();
      });
    }
  }
  changeComponentOnBackButtonClick = () => {
    if (this.changeViewOnBackButtonClick) {
      this.setState({ displaySelectedProductDetail: false, giftSectionType: false });
      this.changeViewOnBackButtonClick = false;
    } else if (this.flag === true) {
      this.flag = false;
      const menu = document.querySelector('.addGiftOptions.visibleContent');
      this.windwidth = window.innerWidth;
      // menu.style.left = this.windwidth + 'px';
      menu.style.left = '100%';
    } else if (this.props.eventDetails && this.props.eventDetails.eventList && this.props.eventDetails.eventList.length > 1) {
      browserHistory.push(applicationRoutes.multipleEvents);
    }
  }

 handlePDFDownload = () => {
  if (this.state.categoryDepartmentId.length === 0) {
    this.setState({ shouldDownloadPdf: true }, () => {
      this.getPaginatedRegisteredGifts(undefined, true);
    });
  } else {
    this.generateAndDownloadPdf();
  }
 };

 generateAndDownloadPdf = () => {
  const pageName = 'lista-de-regalos';
     const downloadableContent = (<DownloadPDFWithoutPreview pageName printingDate={this.props.printingDate} download>
       <Template2
         categoryInfo={this.state.categoryDepartmentId.length === 0 ? this.props.giftList.allRegisteredGiftList.categoryItemsInfo : this.props.registeredItemsInfo}
         lables={this.props.lables}
         registeredGiftList={this.props.giftList && this.props.giftList.registeredGiftList &&
      this.props.giftList.registeredGiftList.filteredRegisteredGiftList ? this.props.giftList.registeredGiftList.filteredRegisteredGiftList : undefined}
         eventDate={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.eventDate}
         eventId={this.eventId}
         eventType={this.props.eventType}
         giftCount={this.totalRegisteredGiftsCount}
       /> </DownloadPDFWithoutPreview>);
     pdfUtil.attachToDom(downloadableContent, pageName);
   }

   setRegistradosWapRef = (instance) => {
    this.registradosWapRef = instance;
   };  

   handleRegistradosWapPDFDownload = () => {
    this.registradosWapRef.handlePDFDownload();
   }
 

   filterGiftListSummaryMarketingContent = (contentSection) => {
    if (contentSection && contentSection.marketing_slots && contentSection.marketing_slots?.length > 0) {
      const filteredMarketingSlots = contentSection.marketing_slots.filter(slot => slot.content_type_uid === "content_download_pdf_container");
      return {
        ...contentSection,
        marketing_slots: filteredMarketingSlots,
      };
    } else {
      return contentSection;
    }
   }


  componentWillReceiveProps(nextProps) {
    if (this.props.loadingPersonalGifts && !nextProps.loadingPersonalGifts && nextProps.giftList && nextProps.giftList.personalShoppingList) {
      const currentPage = nextProps.giftList.personalShoppingList &&
        nextProps.giftList.personalShoppingList.filteredPersonalShoppingList &&
        nextProps.giftList.personalShoppingList.filteredPersonalShoppingList.currentPage ? nextProps.giftList.personalShoppingList.filteredPersonalShoppingList.currentPage : '1';
      const currentItemsInfo = currentPage !== '1' && this.personalItemsInfo ? this.personalItemsInfo : [];
      const itemsInfo = nextProps.giftList.personalShoppingList.filteredPersonalShoppingList &&
        nextProps.giftList.personalShoppingList.filteredPersonalShoppingList.itemsInfo ? nextProps.giftList.personalShoppingList.filteredPersonalShoppingList.itemsInfo : [];
      this.personalItemsInfo = [...currentItemsInfo, ...itemsInfo];
    }

    if (this.props.loadingReceivedGifts && !nextProps.loadingReceivedGifts && nextProps.giftList && nextProps.giftList.receivedGiftList) {
      const currentPage = nextProps.giftList.receivedGiftList &&
        nextProps.giftList.receivedGiftList.filteredReceivedGiftList &&
          nextProps.giftList.receivedGiftList.filteredReceivedGiftList.currentPage ? nextProps.giftList.receivedGiftList.filteredReceivedGiftList.currentPage : '1';
      const currentItemsInfo = currentPage !== '1' && this.receivedItemsInfo ? this.receivedItemsInfo : [];
      const itemsInfo = nextProps.giftList.receivedGiftList.filteredReceivedGiftList &&
        nextProps.giftList.receivedGiftList.filteredReceivedGiftList.itemsInfo ? nextProps.giftList.receivedGiftList.filteredReceivedGiftList.itemsInfo : [];
      this.receivedItemsInfo = [...currentItemsInfo, ...itemsInfo];
      this.receivedItemsInfo = [...new Map(this.receivedItemsInfo.map(i => [i.purchaseItemId, i])).values()];
    }
    if (this.props.loadingRegisteredGifts && !nextProps.loadingRegisteredGifts && nextProps.giftList && nextProps.giftList.registeredGiftList) {
      const payload = nextProps.giftList.registeredGiftList;
      const categoryItemsInfo = payload.filteredRegisteredGiftList.categoryItemsInfo ? payload.filteredRegisteredGiftList.categoryItemsInfo : [];
      this.registeredItemsInfo = categoryItemsInfo;
    }
    const routeChanged = nextProps.location !== this.props.location;
    this.setState({ showBackButton: routeChanged });
  }

  handleSuspendedEventUpdate = (data) => {
    this.suspendedData = data;
    this.eventInfo = data;
  }
  isNotEmpty = obj => obj !== undefined && JSON.stringify(obj) !== JSON.stringify({})
  getDisplayStyle = (brand) => {
    if (brand === commonUtil.getBrand()) {
      return 'hide';
    }
    return '';
  };
  compareEventStatus = (eventStatus, possibleStatus) => {
    if (!eventStatus) {
      return false;
    }
    if (Array.isArray(possibleStatus)) {
      return possibleStatus.filter(status => status.toUpperCase() === eventStatus.toUpperCase()).length;
    }
    return possibleStatus.toUpperCase() === eventStatus.toUpperCase();
  }

  handleBulkAction = (responseData, actionType, removeGiftItems, mode) => {
    if (actionType === 'remove') {
      this.totalRegisteredGiftsCount = this.totalRegisteredGiftsCount - removeGiftItems.length;
      const categoryItemsInfo = JSON.parse(JSON.stringify(this.registeredItemsInfo));
      const updatedCategoryItemsInfo = [];
      for (let catIndex = 0; catIndex < categoryItemsInfo.length; catIndex++) {
        const newCurrentCat = categoryItemsInfo[catIndex].itemInfo.filter(item => removeGiftItems.indexOf(+item.giftItemId) === -1);
        if (newCurrentCat.length) {
          categoryItemsInfo[catIndex].itemInfo = newCurrentCat;
          updatedCategoryItemsInfo.push(categoryItemsInfo[catIndex]);
        }
      }
      this.registeredItemsInfo = updatedCategoryItemsInfo;
      this.setState({ ...this.state });
      return updatedCategoryItemsInfo;
    }
    if (actionType === 'update') {
      const categoryItemsInfo = this.registeredItemsInfo;
      const updatedCategoryItemsInfo = responseData;
      for (let catIndex = 0; catIndex < categoryItemsInfo.length; catIndex++) {
        for (let newCatIndex = 0; newCatIndex < 1; newCatIndex++) {
          const itemInfo = categoryItemsInfo[catIndex].itemInfo;
          const newItemInfo = updatedCategoryItemsInfo.itemInfo;
          for (let itemIndex = 0; itemIndex < itemInfo.length; itemIndex++) {
            for (let newItemIndex = 0; newItemIndex < 1; newItemIndex++) {
              if (itemInfo[itemIndex].giftItemId === newItemInfo.giftItemId) {
                itemInfo[itemIndex].addressId = newItemInfo.deliveryAddress;
                itemInfo[itemIndex].isFavourite = newItemInfo.isFavourite;
                itemInfo[itemIndex].quantity = newItemInfo.quantity;
                itemInfo[itemIndex].deliveryMode = newItemInfo.deliveryType ? newItemInfo.deliveryType : mode;
                break;
              }
            }
          }
        }
      }
      this.registeredItemsInfo = categoryItemsInfo;
      this.setState({ ...this.state });
      return categoryItemsInfo;
    }
    if (actionType === 'favourite') {
      const categoryItemsInfo = this.registeredItemsInfo;
      for (let catIndex = 0; catIndex < categoryItemsInfo.length; catIndex++) {
        const itemInfo = categoryItemsInfo[catIndex].itemInfo;
        for (let itemIndex = 0; itemIndex < itemInfo.length; itemIndex++) {
          if (itemInfo[itemIndex].giftItemId === mode) {
            itemInfo[itemIndex].isFavourite = removeGiftItems;
            break;
          }
        }
      }
      this.registeredItemsInfo = categoryItemsInfo;
      this.setState({ ...this.state });
      return categoryItemsInfo;
    }
    const categoryItemsInfo = JSON.parse(JSON.stringify(this.registeredItemsInfo));
    const updatedCategoryItemsInfo = JSON.parse(JSON.stringify(responseData));
    for (let catIndex = 0; catIndex < categoryItemsInfo.length; catIndex++) {
      for (let newCatIndex = 0; newCatIndex < updatedCategoryItemsInfo.length; newCatIndex++) {
        if (updatedCategoryItemsInfo[newCatIndex].categoryName === categoryItemsInfo[catIndex].categoryName) {
          const itemInfo = categoryItemsInfo[catIndex].itemInfo;
          const newItemInfo = updatedCategoryItemsInfo[newCatIndex].itemInfo;
          for (let itemIndex = 0; itemIndex < itemInfo.length; itemIndex++) {
            for (let newItemIndex = 0; newItemIndex < newItemInfo.length; newItemIndex++) {
              if (itemInfo[itemIndex].giftItemId === newItemInfo[newItemIndex].giftItemId) {
                itemInfo[itemIndex] = newItemInfo[newItemIndex];
                break;
              }
            }
          }
        }
      }
    }
    this.registeredItemsInfo = categoryItemsInfo;
    this.setState({ ...this.state });
    return categoryItemsInfo;
  }

  recieved = () => {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'evTabsAdmin',
      selectOption: 'Regalos Recibidos',
    });
  }

  personal = () => {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'evTabsAdmin',
      selectOption: 'Regalos Personales',
    });
  }

  getSelectedTabValue = (data) => {
    const selectedTab = { registered: false, recieved: false, personal: false, [data]: true };
    let selectedTabIndex;
    if (data === 'recieved') {
      this.tabFlag = 0;
      this.selectedTabIndex = 1;
      selectedTabIndex = 1;
      this.selectedTab = data;
      this.props.setNotificationCount(0);
      this.recieved();
      if(document.getElementById('registeredGiftsFilter') != null){
        document.getElementById('registeredGiftsFilter').style.display = 'none';
        document.getElementById('receivedGiftsFilter').style.display = 'block';
        document.getElementById('PersonalGiftsFilter').style.display = 'none';
      }
    } else if (data === 'personal') {
      this.selectedTabIndex = 2;
      selectedTabIndex = 2;
      this.selectedTab = 'personal';
      this.personal();
      if(document.getElementById('registeredGiftsFilter') != null){
       document.getElementById('registeredGiftsFilter').style.display = 'none';
       document.getElementById('receivedGiftsFilter').style.display = 'none';
       document.getElementById('PersonalGiftsFilter').style.display = 'block';
      }
    } else if(data === 'registered') {
      this.selectedTabIndex = 0;
      selectedTabIndex = 0;
      this.selectedTab = data;
      if (document.getElementById('registeredGiftsFilter') != null) {
        document.getElementById('registeredGiftsFilter').style.display = 'block';
        document.getElementById('receivedGiftsFilter').style.display = 'none';
        document.getElementById('PersonalGiftsFilter').style.display = 'none';
      }
    }else{
      this.selectedTabIndex = 3;
      selectedTabIndex = 3;
      this.selectedTab = data;

      if (document.getElementById('registeredGiftsFilter') != null) {
        document.getElementById('registeredGiftsFilter').style.display = 'none';
        document.getElementById('receivedGiftsFilter').style.display = 'none';
        document.getElementById('PersonalGiftsFilter').style.display = 'none';
      }
    }
    this.setState({ selectedTab, selectedTabIndex });
  }

  handleNextPageClick = () => {
    const tableTop = document.getElementById('tableTop');
    if (!_.isNil(tableTop)) tableTop.scrollIntoView();

    const { selectedTab } = this.state;
    if (selectedTab.registered) {
      const originalRegisteredGiftList = this.props.giftList.registeredGiftList.originalRegisteredGiftList;
      if (_.isNil(originalRegisteredGiftList.currentPage)) originalRegisteredGiftList.currentPage = 1;
      this.getPaginatedRegisteredGifts({ ...originalRegisteredGiftList, currentPage: Number(originalRegisteredGiftList.currentPage) + 1 });
    } else if (selectedTab.recieved) {
      const originalReceivedGiftList = this.props.giftList.receivedGiftList.originalReceivedGiftList;
      if (_.isNil(originalReceivedGiftList.currentPage)) originalReceivedGiftList.currentPage = 1;
      this.getPaginatedReceivedGifts({ ...originalReceivedGiftList, currentPage: Number(originalReceivedGiftList.currentPage) + 1 });
    } else if (selectedTab.personal) {
      const originalPersonalShoppingList = this.props.giftList.personalShoppingList.originalPersonalShoppingList;
      if (_.isNil(originalPersonalShoppingList.currentPage)) originalPersonalShoppingList.currentPage = 1;
      this.getPaginatedPersonalPurchases({ ...originalPersonalShoppingList, currentPage: Number(originalPersonalShoppingList.currentPage) + 1 });
    }
  }

  handlePreviousPageClick = () => {
    const tableTop = document.getElementById('tableTop');
    if (!_.isNil(tableTop)) tableTop.scrollIntoView();

    const { selectedTab } = this.state;
    if (selectedTab.registered) {
      const originalRegisteredGiftList = this.props.giftList.registeredGiftList.originalRegisteredGiftList;
      if (_.isNil(originalRegisteredGiftList.currentPage)) originalRegisteredGiftList.currentPage = 1;
      this.getPaginatedRegisteredGifts({ ...originalRegisteredGiftList, currentPage: Number(originalRegisteredGiftList.currentPage) - 1 });
    } else if (selectedTab.recieved) {
      const originalReceivedGiftList = this.props.giftList.receivedGiftList.originalReceivedGiftList;
      if (_.isNil(originalReceivedGiftList.currentPage)) originalReceivedGiftList.currentPage = 1;
      this.getPaginatedReceivedGifts({ ...originalReceivedGiftList, currentPage: Number(originalReceivedGiftList.currentPage) - 1 });
    } else if (selectedTab.personal) {
      const originalPersonalShoppingList = this.props.giftList.personalShoppingList.originalPersonalShoppingList;
      if (_.isNil(originalPersonalShoppingList.currentPage)) originalPersonalShoppingList.currentPage = 1;
      this.getPaginatedPersonalPurchases({ ...originalPersonalShoppingList, currentPage: Number(originalPersonalShoppingList.currentPage) - 1 });
    }
  }

  handlePageClick = (page) => {
    const tableTop = document.getElementById('tableTop');
    if (!_.isNil(tableTop)) tableTop.scrollIntoView();

    const { selectedTab } = this.state;
    if (selectedTab.registered) {
      const originalRegisteredGiftList = this.props.giftList.registeredGiftList.originalRegisteredGiftList;
      this.getPaginatedRegisteredGifts({ ...originalRegisteredGiftList, currentPage: page });
    } else if (selectedTab.recieved) {
      const originalReceivedGiftList = this.props.giftList.receivedGiftList.originalReceivedGiftList;
      this.getPaginatedReceivedGifts({ ...originalReceivedGiftList, currentPage: page });
    } else if (selectedTab.personal) {
      const originalPersonalShoppingList = this.props.giftList.personalShoppingList.originalPersonalShoppingList;
      this.getPaginatedPersonalPurchases({ ...originalPersonalShoppingList, currentPage: page });
    }
  }

  initialJson = {
    "giftList": {
      "items": [
        {
          "id": 1,
          "name": "Mi mesa de regalos",
          'tabName': "mesa-de-regalos",
          "image": homeicon
        },
        {
          "id": 2,
          "name": "Datos personales",
          'tabName': "datos-personales",
          "image": person
        },
        {
          "id": 3,
          "name": "Personalización",
          'tabName': "personalizacion",
          "image": personalization
        },
        {
          "id":4,
          "name": "Direcciones de entrega",
          'tabName': "direcciones-de-entrega",
          "image": localShipping
        },
        {
          "id": 5,
          "name": "Regalo del evento",
          'tabName': "regalo-del-evento",
          "image": gift
        },
        {
          "id": 6,
          "name": "Contrato",
          'tabName': "contrato",
          "image": article
        },
        {
          "id": 7,
          "name": "Crear mesa",
          'tabName': "crear-mesa",
          "image": add
        }
      ]
    }
  };

  initialJsonWap = {
    "giftList": {
      "items": [
        {
          "id": 1,
          "name": "Datos personales",
          'tabName': "datos-personales",
          "image": person,
          "giftHeader": true,
        },
        {
          "id": 2,
          "name": "Personalización",
          'tabName': "personalizacion",
          "image": personalization,
          "giftHeader" : true
        },
        {
          "id":3,
          "name": "Direcciones de entrega",
          'tabName': "direcciones-de-entrega",
          "image": localShipping,
          "giftHeader" : true
        },
        {
          "id": 4,
          "name": "Regalo del evento",
          'tabName': "regalo-del-evento",
          "image": gift,
          "giftHeader" : false
        },
        {
          "id": 5,
          "name": "Mi ID de mesa de regalos",
          'tabName': "mi-id-mesa-de-regalos",
          "image": barcode,
          "giftHeader" : false
        },
        {
          "id": 6,
          "name": "Contrato",
          'tabName': "contrato",
          "image": article,
          "giftHeader" : true
        },
        {
          "id": 7,
          "name": "Crear mesa",
          'tabName': "crear-mesa",
          "image": add,
          "giftHeader" : false
        },
      ]
    }
  };

  onItemClick = (id, isWapBack, isModal) => {
    // Note: for wap (id == 0), tabName: 'mesa-de-regalos'
    //clearing the localstorage for address if user selects other tab and also clearing the route
    localStorage.removeItem('saveGiftAddress');
    this.setState({ isactiveItem: (id == 0) ? 1 : id });
    let selectedItem;
    if(id != 0){
      if(channel === constChannels.WAP){
        selectedItem = this.initialJsonWap.giftList.items.find(item => item.id === id);
        if (selectedItem?.giftHeader){
         this.props.updateGiftListHeader(selectedItem?.name);
        }
        else if (this.props.globalObject?.giftListHeader != "Mesa de regalos") {
          this.props.updateGiftListHeader("Mesa de regalos");
        }
      } else {
        selectedItem = this.initialJson.giftList.items.find(item => item.id === id);
      }
    }

    if(id == 0){
      selectedItem = {
        tabName: 'mesa-de-regalos'
      }
    }
     
    console.log(`Selected tab name: ${selectedItem.tabName}`);

    if(selectedItem.tabName =='mesa-de-regalos'){
         this.getEventSummaryInfoOnLoad();
    }
    this.setState({ activeBar: (id == 0) ? "mesa-de-regalos" : selectedItem.tabName });
    
    if(isWapBack){
      window.scrollTo(0, 0);
    }

    if(isModal){
      document.body.classList.remove('body-no-scroll');
    }
  }

  onActiveThemeColorUpdate = (themeColor) => {
    this.setState({
      activeThemeColor: themeColor || '#333'
    })
  }

  sortingReceivedGift = (sort) => {
    this.setState({
      receivedGiftsSortingValue: sort || ''
    })
  }


  sortingPersonalPurchases = (sort) => {
    this.setState({
      personalPurchasesSortingValue: sort || ''
    })

  }

 goToEventSearchClickEvent = () => {
    if (browserHistory) {
      const route = applicationRoutes.searchEvent;
      if (route) {
        browserHistory.push(route);
      }
    }
  };

  handleCategoryChange = (selectedData, departmentId) => {
    const departmentIds = departmentId ? [String(departmentId)] : [];
    this.setState({ activeCategory: selectedData, categoryDepartmentId: departmentIds });

    const originalRegisteredGiftList = this.props.giftList.registeredGiftList.originalRegisteredGiftList;
    const categoryDepartmentId =  this.state.categoryDepartmentId;
    const currentPage = categoryDepartmentId.includes(departmentId) ? Number(originalRegisteredGiftList.currentPage) : 1;
    const requestFields = { ...originalRegisteredGiftList, currentPage:currentPage }

    const allowedRequestFields = _.pick(requestFields, [
      'currentPage',
      'searchKeyword',
      'priceOrder',
      'priceOrderCategory',
    ]);
    const definedRequestFields = _.pickBy(
      allowedRequestFields,
      requestField => !_.isNil(requestField),
    );

    this.props.getRegisteredGiftList(
      this.eventId,
      _.defaultTo(definedRequestFields.priceOrder, 'Ascending'),
      definedRequestFields.searchKeyword,
      _.defaultTo(definedRequestFields.priceOrderCategory, 'default'),
      definedRequestFields.currentPage,
      false,
      departmentIds
    );
  };


  renderBonificationsCount = (categoryList, activeCategory, ele, items) => {
      const matchedItem = activeCategory && categoryList.find(item => item.name === activeCategory) 
      let count = '0';
      matchedItem ?
        (ele.value == '1' ? count = matchedItem.totalItemsWithBonus : count = matchedItem.totalItemsWithoutBonus) :
        (ele.value == '1' ? count = items.totalItemsWithBonus : count = items.totalItemsWithoutBonus);

      return count;
  }

  handleCategoryChangeReceivedGift = (selectedData, departmentId) => {
    const departmentIds = departmentId ? String(departmentId) :'';
    
    let filteringParameters = this.state.filterParamsReceivedGift || [];
    const updatedParameters = filteringParameters.filter(item => item.type !== "category");
    if(departmentIds){
      updatedParameters.push({"type":"category","value":departmentIds})
    }
   this.setState({  activeCategoryReceivedGift: selectedData, filterParamsReceivedGift: updatedParameters });

   const originalReceivedGiftList = this.props.giftList.receivedGiftList.originalReceivedGiftList;
  this.getPaginatedReceivedGifts({
    ...originalReceivedGiftList,
        filteringParameters: updatedParameters,
        priceOrder: this.state.receivedGiftsSortingValue,
    });
  };

  handleCategoryChangePersonales = (selectedData, departmentId) => {
    const departmentIds = departmentId ? String(departmentId) : '';

    let filteringParameters = this.state.filterParamsPersonalShoppingList || [];
    const updatedParameters = filteringParameters.filter(item => item.type !== "category");
    if (departmentIds) {
      updatedParameters.push({ "type": "category", "value": departmentIds })
    }
    this.setState({ activeCategoryPersonalShoppingList: selectedData, filterParamsPersonalShoppingList: updatedParameters });


    const originalPersonalShoppingList = this.props.giftList.personalShoppingList.originalPersonalShoppingList;
    this.getPaginatedPersonalPurchases({
      ...originalPersonalShoppingList,
      filteringParameters: updatedParameters,
      priceOrder: this.state.personalPurchasesSortingValue,
    });


  /*   const originalPersonalShoppingList = this.props.giftList.personalShoppingList.originalPersonalShoppingList;
    const categorytIdPersonalShoppingList = this.state.categorytIdPersonalShoppingList;
    const currentPage = categorytIdPersonalShoppingList.includes(departmentId) ? Number(originalPersonalShoppingList.currentPage) : 1;
    const requestFields = { ...originalPersonalShoppingList, currentPage: currentPage }

    const allowedRequestFields = _.pick(requestFields, [
      'searchKeyword',
      'priceOrder',
      'filteringParameters',
      'currentPage',
    ]);
    const definedRequestFields = _.pickBy(
      allowedRequestFields,
      requestField => !_.isNil(requestField),
    );

    this.getPersonalShoppingList(
      definedRequestFields.searchKeyword,
      _.defaultTo(definedRequestFields.priceOrder, 'Ascending'),
      _.defaultTo(definedRequestFields.filteringParameters, []),
      definedRequestFields.currentPage
    ); */
  };


  handleBonificationsChangeReceivedGift = (option, value) => {
    const values = value ? String(value) : '';

    let filteringParameters = this.state.filterParamsReceivedGift || [];
    const updatedParameters = filteringParameters.filter(item => item.type !== "bonusApplicable");
    if (values) {
      updatedParameters.push({ "type": "bonusApplicable", "value": values })
    }
    this.setState({ filterParamsReceivedGift: updatedParameters });

 
   const originalReceivedGiftList = this.props.giftList.receivedGiftList.originalReceivedGiftList;
  this.getPaginatedReceivedGifts({
    ...originalReceivedGiftList,
        filteringParameters: updatedParameters,
        priceOrder: this.state.receivedGiftsSortingValue,
    });
  }

  handleBonificationsChangePersonales = (option, value) =>{
  const values = value ? String(value) : '';

    let filteringParameters = this.state.filterParamsPersonalShoppingList || [];
    const updatedParameters = filteringParameters.filter(item => item.type !== "bonusApplicable");
    if (values) {
      updatedParameters.push({ "type": "bonusApplicable", "value": values })
    }
    this.setState({ filterParamsPersonalShoppingList: updatedParameters });

   const originalPersonalShoppingList = this.props.giftList.personalShoppingList.originalPersonalShoppingList;
    this.getPaginatedPersonalPurchases({
      ...originalPersonalShoppingList,
      filteringParameters: updatedParameters,
      priceOrder: this.state.personalPurchasesSortingValue,
    });
  }

  setCopyToClipboard = async () => {
    const currentUrl = document.URL;
    try {
      await navigator.clipboard.writeText(`${currentUrl}`);
    } finally {
      this.warning.setMessage(commonUtil.getLabel(this.props?.lables?.EventAdminPage, 'adminpage.regalosregistrados.share.warning.message'));
    }
    this.goToTop();
  }


  fallbackCopyUrl = () => {
    const url = window.location.href;
    const textArea = document.createElement('textarea');
    textArea.value = url;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      this.warning.setMessage(commonUtil.getLabel(this.props?.lables?.EventAdminPage, 'adminpage.regalosregistrados.share.warning.message'));
    } catch (err) {
      console.error('Fallback copy failed:', err);
    }
    document.body.removeChild(textArea);
  }


  copyUrlSafely = () => {
    const url = window.location.href;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url)
        .then(() => {
          console.log('URL copied via Clipboard API')
          this.warning.setMessage(commonUtil.getLabel(this.props?.lables?.EventAdminPage, 'adminpage.regalosregistrados.share.warning.message'));
        }
        )
        .catch(err => {
          console.warn('Clipboard API failed, using fallback');
          this.fallbackCopyUrl();
        });
    } else {
      this.fallbackCopyUrl();
    }
  }
  backtoMainHandler = () => {
    this.setState({
      activeBar: 'mesa-de-regalos',
    })
  }

  handleStatementsPageBackWapState = (value) => {
    this.props.updateGiftListHeader(value ? "Statements Table Pages" : "Mesa de regalos");
  }

  handleChatMessageModalWapState = (value) => {
    this.props.updateGiftListHeader(value ? "Responder mensaje" : "Mesa de regalos");
    this.setState({
      activeBar: value ? "chat-message-modal" : "mesa-de-regalos"
    })
  }

  handleChatBackModalOverlay = (isMessageSectionDropDownWapOpen) => {
    const { displayRegalosSelectedProductDetailWap, giftSectionTypeWap } = this.state;
    this.handleChatMessageModalWapState(false);
    this.handleRegalosModalWapState(true, displayRegalosSelectedProductDetailWap, giftSectionTypeWap, isMessageSectionDropDownWapOpen);
  }

  handleRegalosModalWapState = (value,giftDetail,giftSection,isMessageSectionDropDownWapOpen) => {
    this.setState({
      regalosModalWap: value,
      displayRegalosSelectedProductDetailWap: giftDetail,
      giftSectionTypeWap: giftSection,
      isMessageSectionDropDownWapOpen: isMessageSectionDropDownWapOpen || false,
    })
  }


  handleMessagePDFDownload = (allMessages) => {
    const selectedThemeURL = this.state.selectedTheme?.banner_texture?.url || '';
    const activeThemeColor = this.state.activeThemeColor;
    const pageName = this.props?.giftList?.eventSummaryInfo?.eventInfo?.eventId ? `event-messages-${this.props?.giftList?.eventSummaryInfo?.eventInfo?.eventId}` : 'event-messages';
    const downloadableContent = (<DownloadPDFWithoutPreviewMsg isMsgGiftListPdf={true} pageName printingDate={this.props.printingDate} printClass={'printPageMessagePdf'} selectedThemeURL={selectedThemeURL} activeThemeColor={activeThemeColor} download>
      <MessagesTemplate 
       printingDate={this.props.printingDate} 
       eventID={this.eventId}
       eventInfo = {this.props?.giftList?.eventSummaryInfo?.eventInfo || {}}
       allMessages={allMessages}
       lables={this.props.lables}
        /> </DownloadPDFWithoutPreviewMsg>);
    pdfUtil.attachToDom(downloadableContent, pageName);
  }

  setAddAgainAlert = (value) => {
    this.setState({ addAgainAlert: value });
  };

  showMessagePopUp = (success,backToGiftListPage,isAddAgain,customMessage='',showCloseIcon=true) => {
    if(backToGiftListPage){
      if(channel == 'web'){
        this.onItemClick(1,false,false)
      }
      else {
        this.getEventSummaryInfoOnLoad();
        this.setState({
          activeBar : 'mesa-de-regalos'
        })
      }
    }

    window.scrollTo({
      top: 0, 
      behavior: "smooth",
    });
  
    if(success){
      if(isAddAgain){
        this.warning.setMessage(
          customMessage ? customMessage :
          commonUtil.getLabel(
            this.props.lables.EventAdminPage, 
            "adminpage.personalization.gift.added.saved.message"
          ),
          showCloseIcon
        );
      } else {
        this.warning.setMessage(
          customMessage ? customMessage :
          commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.gift.item.added.success.message"
          ),
          showCloseIcon
        );
      }
    } else {
      this.errorMessage.setMessage(
        customMessage ? customMessage :
        commonUtil.getLabel(
          this.props.lables.EventAdminPage,
          "adminpage.regalosrecibidos.add.again.failure.message"
        ),
        showCloseIcon
      );
    }
  }


eventStatusBox = () => {
  const eventStatus = this.props.eventStatusInfo || '';

  let eventIcon = '';
  let eventTitle = '';
  let eventMessage = '';

  if(eventStatus==defaultConst.eventStatus.CLOSED){
    eventIcon = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M19 9L20.25 6.25L23 5L20.25 3.75L19 1L17.75 3.75L15 5L17.75 6.25L19 9ZM11.5 9.5L9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5ZM19 15L17.75 17.75L15 19L17.75 20.25L19 23L20.25 20.25L23 19L20.25 17.75L19 15Z" fill="#27798D"/>
</svg>
    eventTitle=commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.giftlist.eventstatus.closed.title") ||'¡Muchas felicidades!'
    eventMessage = commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.giftlist.eventstatus.closed.message") || 'Tu mesa de regalos se ha cerrado, disfruta de todos tus regalos y beneficios.';
  }

  if(eventStatus==defaultConst.eventStatus.SUSPENDED){
    eventIcon = ''
    eventTitle= commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.giftlist.eventstatus.suspended.title") || 'Mesa de regalos suspendida'
    eventMessage = commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.giftlist.eventstatus.suspended.message") || 'Tu evento fue suspendido por un cambio de fecha. Podrás cerrarlo después de la nueva fecha.';
  }

  if(eventStatus==defaultConst.eventStatus.ADMINISTRATIVE_PROCESS || eventStatus==defaultConst.eventStatus.UNDER_REVIEW){
    eventIcon = ''
    eventTitle=commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.giftlist.eventstatus.adminprocess.title") || 'Asesoría disponible en tienda'
    eventMessage = commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.giftlist.eventstatus.adminprocess.message") || 'Si presentas algún inconveniente con tu mesa de regalos, acude con nuestros asesores a tu tienda de preferencia.';
  }

  if(eventStatus==defaultConst.eventStatus.TEMPORARY_CLOSED){
    eventIcon = ''
    eventTitle=commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.giftlist.eventstatus.tempclosed.title") ||'Mesa de regalos cerrada temporalmente'
    eventMessage = commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.giftlist.eventstatus.tempclosed.message") ||'Tu evento ha entrado a un estado de cierre temporal por 5 minutos. Transcurrido este tiempo tu evento volverá al estatus activo.';
  }

  if(!(eventStatus==defaultConst.eventStatus.CLOSED ||eventStatus==defaultConst.eventStatus.SUSPENDED ||eventStatus==defaultConst.eventStatus.ADMINISTRATIVE_PROCESS || eventStatus==defaultConst.eventStatus.TEMPORARY_CLOSED || eventStatus==defaultConst.eventStatus.UNDER_REVIEW)){
    return ''
  }

  return (
    <div className="eventStatus-box">
      <div>{eventIcon}{eventTitle}</div>
      <div>{eventMessage}</div>
    </div>
  )
}

anadirRegalosDivEnable = () =>{
 const predefinedStatus = defaultConst.RESTRICTED_EVENT_STATUSES;
    let isDisabled = false;
    if (this.compareEventStatus(this.props.eventStatusInfo, predefinedStatus)) {
      isDisabled = true;
    }

    return isDisabled;
}


  renderWeb() {
    const { selectedTab, selectedTabIndex } = this.state;
    let currentPage;
    let totalPages;
    if (selectedTab.registered) {
      currentPage = _.get(this.props, 'giftList.registeredGiftList.originalRegisteredGiftList.currentPage');
      totalPages = _.get(this.props, 'giftList.registeredGiftList.originalRegisteredGiftList.totalPages');
    } else if (selectedTab.recieved) {
      currentPage = _.get(this.props, 'giftList.receivedGiftList.originalReceivedGiftList.currentPage');
      totalPages = _.get(this.props, 'giftList.receivedGiftList.originalReceivedGiftList.totalPages');
    } else if (selectedTab.personal) {
      currentPage = _.get(this.props, 'giftList.personalShoppingList.originalPersonalShoppingList.currentPage');
      totalPages = _.get(this.props, 'giftList.personalShoppingList.originalPersonalShoppingList.totalPages');
    }


    const socialSharePath = 'http:' + serverClientUtil.getMultiSiteURL(commonUtil.getBrand()) + commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: this.eventId });
    const facebookAppID = serverClientUtil.getFacebookAppId(commonUtil.getBrand());
    const brandName = serverClientUtil.brandNames(commonUtil.getBrand());
    const lables = this.props.lables;

    let registeredGiftCount = '';
    let recibidosCount = '';
    let comprasCount = '';

    if (this.tabName && this.tabName === 'received') {
      this.selectedTabIndex = 1;
      this.selectedTab = 'recieved';
    }

    const registeredGiftList = this.props.giftList && this.props.giftList.registeredGiftList &&
      this.props.giftList.registeredGiftList.filteredRegisteredGiftList ? this.props.giftList.registeredGiftList.filteredRegisteredGiftList : undefined;
    if (registeredGiftList !== undefined) {
      registeredGiftCount = registeredGiftList.totalRecords ? registeredGiftList.totalRecords : 0;
      this.totalRegisteredGiftsCount = registeredGiftCount;
    }

    const receivedGiftList = this.props.giftList && this.props.giftList.receivedGiftList &&
      this.props.giftList.receivedGiftList.filteredReceivedGiftList ? this.props.giftList.receivedGiftList.filteredReceivedGiftList : undefined;

    const personalShoppingList = this.props.giftList && this.props.giftList.personalShoppingList &&
      this.props.giftList.personalShoppingList.filteredPersonalShoppingList ? this.props.giftList.personalShoppingList.filteredPersonalShoppingList : undefined;

    if (receivedGiftList !== undefined) {
      recibidosCount = this.props.giftList.receivedGiftList.filteredReceivedGiftList.totalRecords ? this.props.giftList.receivedGiftList.filteredReceivedGiftList.totalRecords : '0';
    }
    if (personalShoppingList !== undefined) {
      comprasCount = this.props.giftList.personalShoppingList.filteredPersonalShoppingList.totalRecords ? this.props.giftList.personalShoppingList.filteredPersonalShoppingList.totalRecords : '0';
    }
    const viewSection =
      this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.ADMINISTRATIVE_PROCESS) ||
        this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.SUSPENDED_FOR_TIME) ? 'enabled' : 'enabled';

    const lpGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.LP) + applicationRoutes.home;
    const wsGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.WS) + applicationRoutes.home;
    const pbGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.PB) + applicationRoutes.home;
    const gapGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.GAP) + applicationRoutes.home;
    const truGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.TRU) + applicationRoutes.home;
    const pbkGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.PBK) + applicationRoutes.home;
    const weGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.WLM) + applicationRoutes.home;

    const tabs = [
      {
        id: 'registered',
        name: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.registered.label'),
        label: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.registered.label'),
        content: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.registered.label'),
        enabled: 'enabled',
      },
      {
        id: 'recieved',
        name: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.recieved.label'),
        label: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.recieved.label'),
        content: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.recieved.label'),
        notifification: this.props.notifificationCount, // this.tabFlag === 0 ? this.tabFlag : (this.newCount || ''),
        enabled: viewSection,
      },
      {
        id: 'personal',
        name: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.personal.label'),
        label: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.personal.label'),
        content: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.personal.label'),
        enabled: viewSection,
      },
      {
        id: 'summary',
        name: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.summary.label'),
        label: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.summary.label'),
        content: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.summary.label'),
        newLabel: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.summary.newlabel'),
        enabled: viewSection,
      },
    ];



      const bonificacions = [
          {
            option:
              lables &&
              commonUtil.getLabel(
                lables.EventAdminPage,
                "adminpage.regalosrecibidos.bonus.dropdown.applicable.label"
              ),
            value: "1",
            disabled: false,
            selected: false,
          },
          {
            option:
              lables &&
              commonUtil.getLabel(
                lables.EventAdminPage,
                "adminpage.regalosrecibidos.bonus.dropdown.notapplicable.label"
              ),
            value: "0",
            disabled: false,
            selected: false,
          },
        ]

const getAccordionFilterData = ({
  title = 'Filtrar',
  labelNamespace,
  categoryList = [],
  activeCategory,
  BonificacionList = [],
  items= [],
  handleCategoryChange,
  handleBonificationsChange,
  filteredBonificationItems = []
}) => [
  {
    title: <span>{title}</span>,
    content: (
      <>
        <div className="filter-title">Categorías</div>
        <ul className="filter-steps">
          <li
            key="default"
            className={`filter-step ${activeCategory === null ? 'active' : ''}`}
            onClick={() => handleCategoryChange(null, null)}
          >
            <div className="dot-line"></div>
            {commonUtil.getLabel(
              lables[labelNamespace],
              'adminpage.regalosregistrados.category.filter.default'
            )}
          </li>
          {categoryList.map((ele, idx) => (
            <li
              key={idx}
              className={`filter-step ${activeCategory === (ele.categoryName || ele.name) ? 'active' : ''}`}
              onClick={() => handleCategoryChange(ele.categoryName || ele.name, ele.departmentId || ele.id)}
            >
              {activeCategory === (ele.categoryName || ele.name) && <div className="dot-line"></div>}
              {ele.categoryName || ele.name}
            </li>
          ))}
        </ul>

         {BonificacionList.length > 0 && this.props.eventType !== defaultConst.eventType.Others && (
          <div className="filter-bonifications">
            <div className="filter-title">Bonificación</div>
            <ul className="filter-bonifications-list">
              <li
            key="default"
            className={`filter-step ${!filteredBonificationItems.find(item => item.type === "bonusApplicable") ? 'active' : ''}`}
            onClick={() => handleBonificationsChange(null, null)}
          >
            {commonUtil.getLabel(
              lables[labelNamespace],
              'adminpage.regalosrecibidos.bonus.dropdown'
            )}
          </li>
              {BonificacionList.map((ele, idx) => (
                <li
                  key={idx}
                  className={`filter-step ${filteredBonificationItems.find(item => item.type === "bonusApplicable")?.value === (ele.value) ? 'active' : ''}`}
                  onClick={() => handleBonificationsChange(ele.option, ele.value)}
                >
                  {ele.option} 
                  <span className="tag-count"> ({this.renderBonificationsCount(categoryList, activeCategory, ele, items)})</span>
                
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    ),
    showOnLoad: true,
  }
];


const accordianFilterData = getAccordionFilterData({
  title: 'Filtrar',
  labelNamespace: 'EventAdminPage',
  categoryList: registeredGiftList?.categoryList || [],
  activeCategory: this.state.activeCategory,
  BonificacionList: [],
  items: registeredGiftList,
  handleCategoryChange: this.handleCategoryChange
});

const accordianFilterDataReceivedGift = getAccordionFilterData({
  title: 'Filtrar',
  labelNamespace: 'EventAdminPage',
  categoryList: receivedGiftList?.categoryList || [],
  activeCategory: this.state.activeCategoryReceivedGift,
  BonificacionList: bonificacions || [],
  items: receivedGiftList || [],
  handleCategoryChange: this.handleCategoryChangeReceivedGift,
  handleBonificationsChange: this.handleBonificationsChangeReceivedGift,
  filteredBonificationItems: this.state.filterParamsReceivedGift || []
});

const accordianFilterDataPersonales = getAccordionFilterData({
  title: 'Filtrar',
  labelNamespace: 'EventAdminPage',
  categoryList: personalShoppingList?.categoryList || [],
  activeCategory: this.state.activeCategoryPersonalShoppingList,
  BonificacionList: bonificacions || [],
  items: personalShoppingList || [],
  handleCategoryChange: this.handleCategoryChangePersonales,
  handleBonificationsChange: this.handleBonificationsChangePersonales,
  filteredBonificationItems: this.state.filterParamsPersonalShoppingList || []
});



    if (!this.props.loading && this.isNotEmpty(registeredGiftList) && this.isNotEmpty(personalShoppingList) && this.isNotEmpty(receivedGiftList) && this.isNotEmpty(this.summaryInfoResponse)) {
      if (!this.recibidosCategory) {
        this.recibidosCategory = receivedGiftList.categoryList ? receivedGiftList.categoryList : [];
      }
      if (!this.comprasCategory) {
        this.comprasCategory = personalShoppingList.categoryList ? personalShoppingList.categoryList : [];
      }

      let warningWidth = '100%';
      let customWarningStyles = {};
      let customWarningStylesStatementSuccess = {};

      if (this.state.selectedTabIndex === 3) {  
        warningWidth = '1200px';
        customWarningStyles = {
          position: "absolute",
          right: "0px",
        }

        customWarningStylesStatementSuccess = {
          position: "absolute",
          right: "7px",
          top: "-71px",
        }
      } else {
        customWarningStyles = {
          position: "absolute",
          right: this.state.selectedTabIndex === 1 ? "288px" : "134px",
          bottom : "15px",
          maxWidth: this.state.selectedTabIndex === 0 ? "920px" : this.state.selectedTabIndex === 1 ? "688px" : "none"
        }
      }

      return (
        <React.Fragment>
        <div className='row'>
          
            
        <div className='gift-list-container-main'>
          <Transition eventId={this.eventId} />
          {/* {this.props.eventStatusInfo && !this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.SUSPENDED_FOR_TIME) && this.props.showThankyouPopUp ?
            <BrandSelectionModal ref={brandModal => this.brandModal = brandModal} lables={this.props.lables} eventId={this.eventId} />
            : ''} */}
          {/* {this.props.eventStatusInfo && this.suspendedData && this.suspendedData.targeterContents && this.suspendedData.targeterContents.length > 0 && */}
          {this.props.eventStatusInfo &&
            <SuspendedEventBanner suspendedData={this.bannerData} eventStatus={this.props.eventStatusInfo} showBanner={this.props.showThankyouPopUp} />
          }
          <div className="gift-list-header-container">
          <aside className="gift-list-sidebar-container">
            <GiftListSidebar
                initialJson={this.initialJson}
                isAgent={this.props.cscAdminProfile?.isAgent || false}
                onItemClick={(id) => {this.onItemClick(id)}}
                isactiveItem={this.state.isactiveItem}
                activeThemeColor={this.state.activeThemeColor}
                giftAvailable={this.props?.userEventThresholdGiftDetails?.data?.giftAvailable || false}
              />
                  {((
                    this.state.activeBar === "mesa-de-regalos") || (this.state.activeBar === "crear-mesa") || (this.state.activeBar === "regalo-del-evento")) &&
                    <div className="gift-list-sidebar">
                      <div className="category-filter">
                        <div className="mode_address_change" id="registeredGiftsFilter" style={{ display: 'block'}}>
                          {this.props.giftList.registeredGiftList?.originalRegisteredGiftList?.categoryList?.length > 0 && (this.state.selectedTabIndex !== 3) &&  (
                            <Accordion items={accordianFilterData} alwaysOpen={0} />
                          )}
                        </div>
                        <div className="mode_address_change" id="receivedGiftsFilter" style={{ display: 'none'}}>
                          {
                            this.props.giftList.receivedGiftList?.originalReceivedGiftList?.categoryList?.length > 0 && (
                                <Accordion items={accordianFilterDataReceivedGift} alwaysOpen={0} />
                            )
                          }
                        </div>
                         <div className="mode_address_change" id="PersonalGiftsFilter" style={{ display: 'none'}}>
                          {
                            this.props.giftList.personalShoppingList.originalPersonalShoppingList?.categoryList?.length > 0 && (
                                <Accordion items={accordianFilterDataPersonales} alwaysOpen={0} />
                            )
                          }
                        </div>
                      </div>
                    </div>
                  }
          </aside>
            <div className={`giftList-main-section ${((this.state.activeBar === "mesa-de-regalos") || (this.state.activeBar === "crear-mesa") || (this.state.activeBar === "regalo-del-evento")) && "gift-list-info"}`}>
                  {/* <div class={`col-xs-12 ${this.state.addAgainAlert ? 'alert-addAgain' : ''}`}> */}
                  <div class={`col-xs-12`}>
          {/* <div class='col-xs-12 alertshare'> */}
            <Warning2
              type="success"
              text={this.warningMessage}
              ref={(warning) => (this.warning = warning)}
              style={{
                width: warningWidth,
                zIndex: 999,
                ...(this.state.selectedTabIndex === 3
                ? customWarningStylesStatementSuccess
                : customWarningStyles),
              }}
              notSetToTop={true}
              onClose={false}
            />
            <Warning2
              type="error"
              text={this.errorMessage}
              ref={(errorMessage) => (this.errorMessage = errorMessage)}
              style={{
                width: warningWidth,
                zIndex: 999,
                ...customWarningStyles,
              }}
              notSetToTop={true}
              onClose={false}
            />
              {/* <Warning2
                type="success"
                onClose
                notSetToTop
                style={{ backgroundColor: '#E7F8EC', marginBottom: '20px' }}
                text={this.errorMessage}
                ref={warning => this.warning = warning}
              /> */}
            </div>
              <div className=''>
              <div className='alert-delete-popup'>
                <Warning2 type={"success"} ref={deleteWarning => this.deleteWarning = deleteWarning} />
              </div>
            {((this.state.activeBar === "mesa-de-regalos") || (this.state.activeBar === "crear-mesa") || (this.state.activeBar === "regalo-del-evento")) && <>
              <div className="row">
                <div className="col-md-12">
                  <div className="event-customization">
                    <EventCardProfile 
                      selectedTheme={this.state.selectedTheme || {}}
                      handleSuspendedEventUpdate={this.handleSuspendedEventUpdate}
                      eventId={this.eventId}
                      hideModal={() => this.brandModal.hideModal}
                      lables={this.props.lables}
                      compareEventStatus={this.compareEventStatus}
                      summaryInfoResponse={this.summaryInfoResponse}
                      icon={this.state.eventIcon}
                      eventInfo = {this.props?.giftList?.eventSummaryInfo?.eventInfo || {}}
                      ownerName={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.user1firstName || ""} coOwnerName={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.user2firstName || ""} CelebrityName={""} message={this.props?.giftList?.eventSummaryInfo?.eventInfo?.comment} eventDateValue={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.eventDate || ""} eventTxtValue={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.eventName || ""}
                      userInfo={this.props?.giftList?.eventSummaryInfo?.eventInfo?.userInfo || {}}
                    />
                  </div>
              </div>
              </div>
              <div className="row">
                <div className="col-md-12">
            <div id="tableTop" className="adminContainer">
              
              {this.eventStatusBox()}
              <div className="giftListSearch-box">
                <button
                  className="inputMaterial newInput gift-mode"
                  htmlId="searchArea"
                  required="true"
                  onClick={() => this.goToEventSearchClickEvent()}                  
                  >
                    <i className="glyphicon glyphicon-search"></i>
                   <span>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.search.placeholder')}</span>
                </button>
               
              </div>
              <Tabs tabs={tabs} selectedTabIndex={selectedTabIndex} selectedTab={this.selectedTab} callbackAfterTabChanging={this.getSelectedTabValue} selectedTheme={this.state.selectedTheme || {}}>
                <RegisteredGiftsWeb
                  loadingRegisteredGifts={this.props.loadingRegisteredGifts}
                  loadingAllRegisteredGifts={this.props.loadingAllRegisteredGifts}
                  sorting={this.sorting}
                  eventId={this.eventId}
                  registeredGiftList={registeredGiftList}
                  allRegisteredGifts={this.props.giftList.allRegisteredGiftList}
                  categoryInfo={this.registeredItemsInfo}
                  handleSortAndFilter={this.getRegisteredGiftList}
                  eventInfo={this.eventInfo}
                  setTotalRecordsForType={this.setTotalRecordsForType}
                  lables={this.props.lables}
                  compareEventStatus={this.compareEventStatus}
                  changeAllowUpdate={this.changeAllowUpdate}
                  handleBulkAction={this.handleBulkAction}
                  giftCount={this.totalRegisteredGiftsCount}
                  originalRegisteredGiftList={this.props.giftList.registeredGiftList.originalRegisteredGiftList}
                  getPaginatedRegisteredGifts={this.getPaginatedRegisteredGifts}
                  shareModal={this.state.shareModal.web}
                  activeCategory={this.state.activeCategory}
                  setCopyToClipboard = {this.copyUrlSafely}
                  categoryDepartmentId ={this.state.categoryDepartmentId}
                  initialRegisteredGiftList={this.props.giftList.registeredGiftList.originalRegisteredGiftList}
                  deletePopup={this.deleteWarning}                  
                />
                <ReceivedGiftsWeb
                  eventId={this.eventId}
                  receivedGiftList={receivedGiftList}
                  receivedItemsInfo={this.receivedItemsInfo}
                  handleSortAndFilter={this.getRecievedGiftList}
                  getRecievedGiftList={this.getRecievedGiftList}
                  setTotalRecordsForType={this.setTotalRecordsForType}
                  lables={this.props.lables}
                  compareEventStatus={this.compareEventStatus}
                  recibidosCategory={this.recibidosCategory}
                  originalReceivedGiftList={this.props.giftList.receivedGiftList.originalReceivedGiftList}
                  getPaginatedReceivedGifts={this.getPaginatedReceivedGifts}
                  shareModal={this.state.shareModal.web}
                  handleMessagePDFDownload={this.handleMessagePDFDownload}
                  filterParamsReceivedGift ={this.state.filterParamsReceivedGift}
                  getSorting={this.sortingReceivedGift}
                  setAddAgainAlert={this.setAddAgainAlert}
                  showMessagePopUp={this.showMessagePopUp}
                  inititialReceivedItems={this.props.giftList.receivedGiftList.originalReceivedGiftList}
                  selectedTheme={this.state.selectedTheme || {}}
                />
                <PersonalPurchasesWeb
                  eventId={this.eventId}
                  handleSortAndFilter={this.getPersonalShoppingList}
                  personalShoppingList={personalShoppingList}
                  comprasCategory={this.comprasCategory}
                  personalItemsInfo={this.personalItemsInfo}
                  setTotalRecordsForType={this.setTotalRecordsForType}
                  lables={this.props.lables}
                  compareEventStatus={this.compareEventStatus}
                  originalPersonalShoppingList={this.props.giftList.personalShoppingList.originalPersonalShoppingList}
                  getPaginatedPersonalPurchases={this.getPaginatedPersonalPurchases}
                  filterParamsPersonalShoppingList = {this.state.filterParamsPersonalShoppingList}
                  sorting={this.sortingPersonalPurchases}
                  initialPersonalPurchaseList={this.props.giftList.personalShoppingList.originalPersonalShoppingList}
                  showMessagePopUp={this.showMessagePopUp}
                  selectedTheme={this.state.selectedTheme || {}}
                />
                
                <GiftListSummary 
                  ref={accountStatus => this.accountStatus = accountStatus}
                  lables={this.props.lables}
                  accountStatus={this.props.accountStatus}
                  intransitData={this.props.intransitData}
                  eventInfo={this.props?.giftList?.eventSummaryInfo?.eventInfo || {}}
                  eventId={this.eventId}
                  user={this.props.user}
                  statementDetailsForPrintAndDownloadData={this.props.statementDetailsForPrintAndDownloadData}
                  printingDate={this.props.printingDate}
                  selectedTheme={this.state.selectedTheme || this.defaultTheme}
                  showMessagePopUp={this.showMessagePopUp}
                  disableAnadirRegalos = {this.anadirRegalosDivEnable()}
                />
              </Tabs>
            </div>

</div>

          </div>

           <PaginationIndicator
            currentPage={currentPage}
            totalPages={totalPages}
            onPreviousClick={this.handlePreviousPageClick}
            onNextClick={this.handleNextPageClick}
            onPageClick={this.handlePageClick}
          />

          {(this.state.selectedTabIndex != 3) &&
            <AddGiftsButton 
              selectedTheme ={this.state.selectedTheme || {}}
              lables = {this.props.lables}
              selectedTab = {this.selectedTab}
              isDisable = {this.anadirRegalosDivEnable()}
            />
          }

               {/* <GiftListHeader
                handleSuspendedEventUpdate={this.handleSuspendedEventUpdate}
                eventId={this.eventId}
                hideModal={() => this.brandModal.hideModal}
                lables={this.props.lables}
                compareEventStatus={this.compareEventStatus}
                summaryInfoResponse={this.summaryInfoResponse}
              /> */}

          <div className="row">
              <div className="col-xs-12">
                <MarketingContentSection 
                  contentSection={(this.state.selectedTabIndex !== 0) ? this.filterGiftListSummaryMarketingContent(this.props.giftlistMarketingContent)  : this.props.giftlistMarketingContent} 
                  store={this.props} 
                  downloadPdfData={{
                    handlePDFDownload: this.handlePDFDownload,
                    selectedTheme: this.state.selectedTheme || this.defaultTheme || {},
                    lables: this.props.lables,
                    selectedTab: this.selectedTab,
                    isDisable: this.anadirRegalosDivEnable(),
                    eventType: this.props.eventType,
                    eventChecklistPdfUrl: this.props.eventCategory?.eventConfigurations?.find(eventConfig => eventConfig.name === this.props.eventType)?.event_checklist_pdf_url?.href || "",
                  }}
                />
              </div>
          </div>

          <ModalPopover
            ref={(ref) => {
              if (_.isNil(this.state.shareModal.web)) {
                this.setState({ shareModal: { web: ref } });
              }
            }}
            modalId="sharingModal"
            isModal="true"
          >
            <button id="closeModal" className="btnClose" type="button" data-dismiss="modal" aria-label="Close">
              <i>×</i>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              <b>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.sharemylist.label')}</b>
            </h4>
            <div>
              <hr className="divider" />
              <div className="row">
                <div className="col-xs-12">
                  <FacebookProvider appId={facebookAppID}>
                    <ShareButton
                      href={socialSharePath}
                      className="btn btn-labeled btn-primary center-block"
                      iconClassName=""
                      icon=""
                      type="button"
                    >
                      <span className="btn-label">
                        <i className="iClass icon-social-facebook" />
                      </span>
                      <span className="btn-txt">
                        {commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.socialshare.facebook.label')}
                      </span>
                    </ShareButton>
                  </FacebookProvider>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <a href={`https://twitter.com/intent/tweet?url=${socialSharePath}&via=${brandName}`} target="popup">
                    <button className="btn btn-labeled btn-info center-block" type="button">
                      <span className="btn-label">
                        <i className="iClass icon-social-twitter" />
                      </span>
                      <span className="btn-txt">
                        {commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.socialshare.twitter.label')}
                      </span>
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </ModalPopover>
            </>}


        {
                this.state.activeBar === "datos-personales" &&
                <div>
                  <PersonalData 
                  eventStatusInfo={this.props.eventStatusInfo || ''}
                  eventId={this.eventId}
                  profileId={this.props.user.result.profileId}
                  eventType={this.props.eventType}
                  user={this.props.user}
                  selectedTheme ={this.state.selectedTheme || {}}
                  />
                </div>
              }
              {
                this.state.activeBar === "direcciones-de-entrega" &&
                <DeliveryAddress
                  // eventId={'560035'}
                  // profileId={'9945536225'} 
                  profileId={this.props.user.result.profileId}
                  eventId={this.eventId}
                  user={this.props.user}
                  selectedTheme ={this.state.selectedTheme || {}}              
                  showMessagePopUp={this.showMessagePopUp}          
                  eventStatusInfo={this.props.eventStatusInfo || ''}
                 
                />
              }
              {this.state.activeBar === "personalizacion" && (
                <Personalization  
                  // eventID={'560035'}
                  eventID={this.eventId} 
                  lables={this.props.lables} 
                  eventType={this.props.eventType}
                  user={this.props.user}
                  // profileId={'9945536225'} 
                  profileId={this.props.user.result.profileId}
                  userEventDetails={this.props.userEventDetails}
                  getEventDetails={this.props.getEventDetails}
                  eventcategory={this.props.eventCategory}
                  onActiveThemeColorUpdate={this.onActiveThemeColorUpdate}
                  showMessagePopUp={this.showMessagePopUp}
                  selectedTheme ={this.state.selectedTheme || {}}
                  eventStatusInfo={this.props.eventStatusInfo || ''}
                />
              )}
              {this.state.activeBar === "contrato" && (
                <ContractEM eventID={this.eventId} lables={this.props.lables} userEventDetails={this.props.userEventDetails} selectedTheme ={this.state.selectedTheme || {}}/>
              )}

              {this.state.activeBar === "regalo-del-evento" && (
                <EventGiftModalOverlay 
                  hideModalOverlay={() => {this.onItemClick(1,false,true)}}
                  getEventThresholdGiftDetails={this.props.getEventThresholdGiftDetails}
                  getPurchaseInfoDetails={this.props.getPurchaseInfoDetails}
                  userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails}
                  purchaseInfoDetails={this.props.purchaseInfoDetails}
                  userEventDetails={this.props.userEventDetails}
                  deliveryAddress={this.props.deliveryAddress}
                  selectedTheme={this.state.selectedTheme || {}}
                  lables={this.props.lables}
                  eventInfo={this.props?.giftList?.eventSummaryInfo?.eventInfo || {}}
                />
              )}

              {this.state.activeBar === "crear-mesa" && (
                <CreateTableModalOverlay 
                  hideModalOverlay={() => {this.onItemClick(1,false,true)}}
                  allowedEventTypes={this.props.allowedEventTypes}
                  selectedTheme ={this.state.selectedTheme || {}} 
                />
              )}
      </div>
      </div>
          
        </div>
        </div>
        </div>
        {((this.state.activeBar === "mesa-de-regalos"))  &&
              <div className="row giftlist-web-carousel-section">
                  <div className="col-xs-12">
                    <MarketingContentSection contentSection={this.props.giftlistFooterMarketingContent} store={this.props} />
                  </div>
              </div>
        }
         </React.Fragment>
      );
    }
    return null;
  }

  windwidth = '';

  showCatalog = () => {
    commonUtil.goToTop();
    this.flag = true;
    const menu = document.querySelector('.addGiftOptions.visibleContent');
    this.windwidth -= 1;
    menu.style.left = 0 + 'px';
    menu.style.opacity = 1;
  }
  accountStatusRoute = () => {
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.accountStatus, { eventID: this.eventId }));
  }
  renderWap() {
    const lables = this.props.lables;
    let registeredGiftCount = '';
    let recibidosCount = '';
    let comprasCount = '';

    const socialSharePath = 'http:' + serverClientUtil.getMultiSiteURL(commonUtil.getBrand()) + commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: this.eventId });
    const facebookAppID = serverClientUtil.getFacebookAppId(commonUtil.getBrand());
    const brandName = serverClientUtil.brandNames(commonUtil.getBrand());
    const shareModalHeaderData = (
      <React.Fragment>
        <div
          onClick={
            _.isNil(this.state.shareModal.wap) ? undefined : this.state.shareModal.wap.handleHide
          }
        >
          <p>
            {commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              'adminpage.regalosregistrados.cerrar.label',
            )}
          </p>
          <button className="close" type="button" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <h4 className="modal-title" id="myModalLabel">
          {commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            'adminpage.regalosregistrados.sharemylist.label',
          )}
        </h4>
      </React.Fragment>
    );

    const registeredGiftList = this.props.giftList &&
      this.props.giftList.registeredGiftList && this.props.giftList.registeredGiftList.filteredRegisteredGiftList ? this.props.giftList.registeredGiftList.filteredRegisteredGiftList : undefined;


    if (this.tabName && this.tabName === 'received') {
      this.selectedTabIndex = 1;
      this.selectedTab = 'recieved';
    }

    if (registeredGiftList !== undefined) {
      registeredGiftCount = registeredGiftList.totalRecords ? registeredGiftList.totalRecords : 0;
      this.totalRegisteredGiftsCount = registeredGiftCount;
    }

    const receivedGiftList = this.props.giftList &&
      this.props.giftList.receivedGiftList && this.props.giftList.receivedGiftList.filteredReceivedGiftList ? this.props.giftList.receivedGiftList.filteredReceivedGiftList : undefined;

    const personalShoppingList = this.props.giftList &&
      this.props.giftList.personalShoppingList &&
      this.props.giftList.personalShoppingList.filteredPersonalShoppingList ? this.props.giftList.personalShoppingList.filteredPersonalShoppingList : undefined;

    if (receivedGiftList !== undefined) {
      recibidosCount = this.props.giftList.receivedGiftList.filteredReceivedGiftList.totalRecords ? this.props.giftList.receivedGiftList.filteredReceivedGiftList.totalRecords : '0';
    }
    if (personalShoppingList !== undefined) {
      comprasCount = this.props.giftList.personalShoppingList.filteredPersonalShoppingList.totalRecords ? this.props.giftList.personalShoppingList.filteredPersonalShoppingList.totalRecords : '0';
    }

    const lpGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.LP) + applicationRoutes.home;
    const wsGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.WS) + applicationRoutes.home;
    const pbGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.PB) + applicationRoutes.home;
    const gapGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.GAP) + applicationRoutes.home;
    const pbkGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.PBK) + applicationRoutes.home;
    const weGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.WLM) + applicationRoutes.home;
    const truGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.TRU) + applicationRoutes.home;
    const viewSection =
      this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.ADMINISTRATIVE_PROCESS) ||
      this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.SUSPENDED_FOR_TIME) ? 'disabled' : 'enabled';

    const tabs = [
      {
        "id": "registered",
        "name": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.registered.label'),
        "label": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.registered.label'),
        "content": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.registered.label'),
        "enabled": "enabled"
      },
      {
        "id": "recieved",
        "name": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.recieved.label'),
        "label": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.recieved.label'),
        "content": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.recieved.label'),
        "notifification": "0",
        "enabled": "enabled"
      },
      {
        "id": "personal",
        "name": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.personal.label'),
        "label": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.personal.label'),
        "content": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.personal.label'),
        "enabled": "enabled"
      },
      {
        "id": "summary",
        "name": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.summary.label'),
        "label": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.summary.label'),
        "content": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.summary.label'),
        "enabled": "enabled",
        "newLabel": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.tab.summary.newlabel'),
      }
    ]
    this.windwidth = window.innerWidth;

    const style = {
      left: this.windwidth + 'px',
      opacity: 0,
    };
    const AccountStatusButton = {
      type: 'button',
      value: lables ? commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.eventaccontpage.hyperlink.message') : 'Estado de cuenta',
      autoFocus: false,
      style: this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.ADMINISTRATIVE_PROCESS) ||
        this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.SUSPENDED_FOR_TIME) ? 'btnSecondarySpecial size-Full btnSecondarySpecialDisable' : 'btnSecondarySpecial size-Full',
      onClickHandler: this.accountStatusRoute,
      disabled: this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.ADMINISTRATIVE_PROCESS) ||
        this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.SUSPENDED_FOR_TIME) ? 'disabled' : '',
    };
    const AgregarRegalosButton = {
      type: 'button',
      value: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.addagift.dropdown.message'),
      autoFocus: false,
      style: this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.SUSPENDED) ? 'btnPrimarySpecial size-Full btnPrimarySpecialDisable' : 'btnPrimarySpecial size-Full',

      disabled: this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.SUSPENDED) ? 'disabled' : '',
      iconClass: 'icon-flecha_lightsvg_derecha',
      onClickHandler: this.showCatalog,
    };

    const _url = serverClientUtil.getLPFullURL() + '/home';

    const linkJSON = [];
    let predeterminedPageRoute = commonUtil.getRouteByParameter(applicationRoutes.predeterminedLists, { eventType: this.props.eventType ? this.props.eventType : '', eventID: this.eventId });
    if (this.props.predeterminedListId === false) {
      predeterminedPageRoute = '';
    }
    let catalogName = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.catalog.lp.label');
    if (commonUtil.getBrand() === defaultConst.constBrand.PB) {
      catalogName = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.catalog.pb.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.PBK) {
      catalogName = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.catalog.pbk.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.GAP) {
      catalogName = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.catalog.gap.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.WLM) {
      catalogName = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.catalog.wlm.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.WS) {
      catalogName = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.catalog.ws.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.TRU) {
      catalogName = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.catalog.tru.label');
    }
    const CatálogoLiverpool =
      {
        displayName: catalogName,
        children: 'Catálogo Liverpool ',
        areaLabel: 'abc',
        href: _url,
        id: 'lnkLPWeb',
        class: 'linkClass',
      };
    const Listaspredeterminadas = {
      displayName: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.default.lists.label'),
      children: 'Listas predeterminadas  ',
      areaLabel: 'abc',
      route: predeterminedPageRoute,
      class: 'linkClass',
    };
    const Sugerenciaderegalos = {
      displayName: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.gift.suggetion.label'),
      children: 'Sugerencia de regalos  ',
      areaLabel: 'abc',
      href: this.props.suggestionLink ? this.props.suggestionLink : '',
      class: 'linkClass',
    };

    linkJSON.push(CatálogoLiverpool);
    if (commonUtil.getBrand() === defaultConst.constBrand.LP && this.props.eventSummaryInfoHeader === true) {
      linkJSON.push(Listaspredeterminadas);
    }
    if (this.props.suggestionLink && this.props.suggestionLink !== '') {
      linkJSON.push(Sugerenciaderegalos);
    }


    if (!this.props.loading && this.isNotEmpty(registeredGiftList) && this.isNotEmpty(personalShoppingList) && this.isNotEmpty(receivedGiftList)) {
      if (!this.recibidosCategory) {
        this.recibidosCategory = receivedGiftList.categoryList ? receivedGiftList.categoryList : [];
      }
      if (!this.comprasCategory) {
        this.comprasCategory = personalShoppingList.categoryList ? personalShoppingList.categoryList : [];
      }
      return (
        !this.state.displaySelectedProductDetail ? <React.Fragment>    
          <Warning2
            type="success"
            text={this.warningMessage}
            ref={(warning) => (this.warning = warning)}
            style={{
              position: 'absolute',
              top: '171px',
              width: '92%',
              zIndex: 999,
            }}
            notSetToTop={true}
            onClose={false}
          />
          <Warning2
            type="error"
            text={this.errorMessage}
            ref={(errorMessage) => (this.errorMessage = errorMessage)}
            style={{
              position: 'absolute',
              top: '171px',
              width: '92%',
              zIndex: 999,
            }}
            notSetToTop={true}
            onClose={false}
          />
          <Warning2
            type="success"
            ref={deleteWarning => this.deleteWarning = deleteWarning}
            style={{
              position: 'absolute',
              top: '171px',
              width: '80%',
              zIndex: 999,
              left: '10%',
            }}
            // notSetToTop={true}
            onClose={false}
          />
          <Transition eventId={this.eventId} />
          {this.props.eventStatusInfo &&
            !this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.SUSPENDED_FOR_TIME) &&
            this.props.showThankyouPopUp &&
            (applicationRoutes.giftList.replace('(/:eventID)', '/' + this.props.params.eventID) === (typeof window !== 'undefined' && window.location.pathname)) ?
              // <EventCreationThanksModalWap open={this.props.showThankyouPopUp} onCloseClick={() => this.props.setPageFlag(false)} />
              null 
              :
               ''}
          {((this.state.activeBar === "mesa-de-regalos") || (this.state.activeBar === "crear-mesa") || (this.state.activeBar === "regalo-del-evento") || (this.state.activeBar === "mi-id-mesa-de-regalos")) &&
           <>
          <div className="row home-container gift-list-header-container">
            <div className="col-xs-12" style={{ position: 'relative' }}>
              <div className="row">
                <div className="event-customization">
                  <EventCardProfile
                    initialJson={this.initialJsonWap}
                    onItemClick={(id) => {this.onItemClick(id)}}
                    isactiveItem={this.state.isactiveItem}
                    selectedTheme={this.state.selectedTheme || {}}
                    handleSuspendedEventUpdate={this.handleSuspendedEventUpdate}
                    eventId={this.eventId}
                    hideModal={() => this.brandModal.hideModal}
                    lables={this.props.lables}
                    compareEventStatus={this.compareEventStatus}
                    summaryInfoResponse={this.summaryInfoResponse}
                    icon={this.state.eventIcon}
                    eventInfo={this.props?.giftList?.eventSummaryInfo?.eventInfo || {}}
                    ownerName={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.user1firstName || ""} coOwnerName={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.user2firstName || ""} CelebrityName={""} message={this.props?.giftList?.eventSummaryInfo?.eventInfo?.comment} eventDateValue={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.eventDate || ""} eventTxtValue={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.eventName || ""}
                    userInfo={this.props?.giftList?.eventSummaryInfo?.eventInfo?.userInfo || {}}
                    giftAvailable={this.props?.userEventThresholdGiftDetails?.data?.giftAvailable || false}
                    isAgent={this.props.cscAdminProfile?.isAgent || false}
                  />
                </div>
              </div>
             
              {/* <GiftListHeaderWap
                showBanner={this.props.showThankyouPopUp}
                selectedTheme={this.state.selectedTheme || {}}
                handleSuspendedEventUpdate={this.handleSuspendedEventUpdate}
                eventId={this.eventId}
                hideModal={() => this.brandModal.hideModal}
                lables={this.props.lables}
                compareEventStatus={this.compareEventStatus}
                summaryInfoResponse={this.summaryInfoResponse}
                icon={this.state.eventIcon}
                eventInfo={this.props?.giftList?.eventSummaryInfo?.eventInfo || {}}
                ownerName={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.user1firstName || ""} coOwnerName={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.user2firstName || ""} CelebrityName={""} message={"¡Estamos celebrando un momento único y lleno de emoción! Gracias por ser parte de él."} eventDateValue={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.eventDate || ""} eventTxtValue={this.props?.giftList?.eventSummaryInfo?.eventDetailsInfo?.eventName || ""}
              /> */}

              {/* { (this.state.selectedTabIndex == 3) &&
                this.props && 
                this.props.accountStatus && 
                this.props.accountStatus.eventAccountStatementInfo && 
                this.props.accountStatus.eventAccountStatementInfo.eventMessage &&
                this.props.accountStatus.eventAccountStatementInfo.eventMessage.indexOf('Muchas') > -1 &&
                <div className="message-box-wap">
                  <div className="message-header-wap">
                    <div className="message-svg-icon-wap">
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                        <path d="M19.5 9L20.75 6.25L23.5 5L20.75 3.75L19.5 1L18.25 3.75L15.5 5L18.25 6.25L19.5 9ZM12 9.5L9.5 4L7 9.5L1.5 12L7 14.5L9.5 20L12 14.5L17.5 12L12 9.5ZM19.5 15L18.25 17.75L15.5 19L18.25 20.25L19.5 23L20.75 20.25L23.5 19L20.75 17.75L19.5 15Z" fill="#27798D"/>
                      </svg>
                    </div>
                    <div className="message-title-wap">{commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.muchas.felicidades.message',
                        )}</div>
                  </div>
                  <div className="message-description-wap">
                      {commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.muchas.congratulation.message',
                        )}
                  </div>
                </div>
              } */}

              {this.eventStatusBox()}
              <div className="giftListSearch-box">
                <button
                  className="inputMaterial newInput gift-mode wapGiftSearch"
                  htmlId="searchArea"
                  required="true"
                  onClick={() => this.goToEventSearchClickEvent()}
                  >
                    <i className="glyphicon glyphicon-search"></i>
                    <span>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.search.placeholder')}</span>
                </button>
              </div>
             {/* <div className="row eventBlock">
                {
                this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.VALIDITY_OFF_ACTIVE) ||
                this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.CLOSED) ||
                this.compareEventStatus(this.props.eventStatusInfo, defaultConst.eventStatus.TEMPORARY_CLOSED) ? <div className="col-xs-12 mt-15">
                  <InputButton buttonAttr={AccountStatusButton} />
                </div> :
                <React.Fragment>
                  <div className="col-xs-12">
                    <div className="dropdown">
                      <InputButton buttonAttr={AgregarRegalosButton} />
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <InputButton buttonAttr={AccountStatusButton} />
                  </div></React.Fragment>
                }

              </div> */}
              <div className="row adminTabsContainer">
                {/* <div className="intro col-xs-12">
                  <h2>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.mydata.message')}</h2>
                  <p>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.giftsonlyfromliverpool.message')}</p>
                </div> */}
                <Tabs tabs={tabs} cssClass={'tabs col-xs-12'} selectedTabIndex={this.selectedTabIndex} selectedTab={this.selectedTab} callbackAfterTabChanging={this.getSelectedTabValue} selectedTheme={this.state.selectedTheme || {}}>
                  <RegisteredGiftsWap
                    eventId={this.eventId}
                    registeredGiftList={this.registeredItemsInfo}
                    registeredGifts={registeredGiftList}
                    allRegisteredGifts={this.props.giftList.allRegisteredGiftList}
                    loadingAllRegisteredGifts={this.props.loadingAllRegisteredGifts}
                    handleSortAndFilter={this.getPaginatedRegisteredGifts}
                    eventInfo={this.eventInfo}
                    setTotalRecordsForType={this.setTotalRecordsForType}
                    lables={this.props.lables}
                    compareEventStatus={this.compareEventStatus}
                    categoryInfo={this.registeredItemsInfo}
                    changeAllowUpdate={this.changeAllowUpdate}
                    handleBulkAction={this.handleBulkAction}
                    giftCount={this.totalRegisteredGiftsCount}
                    originalRegisteredGiftList={this.props.giftList.registeredGiftList.originalRegisteredGiftList}
                    onAddGiftsLinkClick={this.showCatalog}
                    shareModal={this.state.shareModal.wap}
                    selectedTheme={this.state.selectedTheme || {}}
                    activeThemeColor={this.state.activeThemeColor}
                    deletePopup={this.deleteWarning}
                    initialGiftListItems={this.props.giftList.registeredGiftList.originalRegisteredGiftList}
                    disableAnadirRegalos = {this.anadirRegalosDivEnable()}
                    onRegistradosWapRef={this.setRegistradosWapRef}
                  />

                  <ReceivedGiftsWap
                    selectedProductForPreview={this.selectedProductForPreview}
                    eventId={this.eventId}
                    receivedGiftList={receivedGiftList}
                    receivedItemsInfo={this.receivedItemsInfo}
                    handleSortAndFilter={this.getPaginatedReceivedGifts}
                    getRecievedGiftList={this.getRecievedGiftList}
                    setTotalRecordsForType={this.setTotalRecordsForType}
                    lables={this.props.lables}
                    selectedTheme={this.state.selectedTheme || {}}
                    activeThemeColor= {this.state.activeThemeColor || ''}
                    categoryInfo={this.registeredItemsInfo}
                    giftCount={this.totalRegisteredGiftsCount}
                    compareEventStatus={this.compareEventStatus}
                    recibidosCategory={this.recibidosCategory}
                    sortingTypeForFilter={this.sortingTypeForFilter}
                    selectedFilteringParameters={this.selectedFilteringParameters}
                    eventType={this.props.eventType}
                    originalReceivedGiftList={this.props.giftList.receivedGiftList.originalReceivedGiftList}
                    shareModal={this.state.shareModal.wap}
                    ref={this.receivedGiftsWapRef}
                    handleChatMessageModalWapState={this.handleChatMessageModalWapState}
                    handleRegalosModalWapState={this.handleRegalosModalWapState}
                    regalosModalWap={this.state.regalosModalWap}
                    displaySelectedProductDetail={this.state.displayRegalosSelectedProductDetailWap}
                    isMessageSectionDropDownWapOpen={this.state.isMessageSectionDropDownWapOpen}
                    giftSectionType={this.state.giftSectionTypeWap}
                    handleMessagePDFDownload={this.handleMessagePDFDownload}
                    showMessagePopUp={this.showMessagePopUp}
                    initialReceivedItems={this.props.giftList.receivedGiftList.originalReceivedGiftList}
                    disableAnadirRegalos = {this.anadirRegalosDivEnable()}
                  />

                  <PersonalPurchasesWap
                    selectedProductForPreview={this.selectedProductForPreview}
                    eventId={this.eventId}
                    handleSortAndFilter={this.getPaginatedPersonalPurchases}
                    personalShoppingList={personalShoppingList}
                    personalItemsInfo={this.personalItemsInfo}
                    setTotalRecordsForType={this.setTotalRecordsForType}
                    lables={this.props.lables}
                    selectedTheme={this.state.selectedTheme || {}}
                    activeThemeColor= {this.state.activeThemeColor || ''}
                    categoryInfo={this.registeredItemsInfo}
                    giftCount={this.totalRegisteredGiftsCount}
                    compareEventStatus={this.compareEventStatus}
                    comprasCategory={this.comprasCategory}
                    eventType={this.props.eventType}
                    eventInfo={this.props?.giftList?.eventSummaryInfo?.eventInfo || {}}
                    originalPersonalShoppingList={this.props.giftList.personalShoppingList.originalPersonalShoppingList}
                    disableAnadirRegalos = {this.anadirRegalosDivEnable()}
                    initialPersonalPurchaseList={this.props.giftList.personalShoppingList.originalPersonalShoppingList}
                    showMessagePopUp={this.showMessagePopUp}
                  />

                  
                  <GiftListSummary 
                    ref={accountStatus => this.accountStatus = accountStatus}
                    lables={this.props.lables}
                    accountStatus={this.props.accountStatus}
                    intransitData={this.props.intransitData}
                    eventInfo={this.props?.giftList?.eventSummaryInfo?.eventInfo || {}}
                    eventId={this.eventId}
                    user={this.props.user}
                    statementDetailsForPrintAndDownloadData={this.props.statementDetailsForPrintAndDownloadData}
                    printingDate={this.props.printingDate}
                    selectedTheme={this.state.selectedTheme || this.defaultTheme}
                    showMessagePopUp={this.showMessagePopUp}
                    handlePDFDownload={this.handlePDFDownload}
                    selectedTab={this.selectedTab}
                    handleStatementsPageBackWapState={this.handleStatementsPageBackWapState}
                    disableAnadirRegalos = {this.anadirRegalosDivEnable()}
                  />
                </Tabs>
              </div>

              <div className="row giftlist-web-carousel-section">
                 <div className="col-xs-12">
                   <MarketingContentSection 
                      contentSection={(this.state.selectedTabIndex !== 0) ? this.filterGiftListSummaryMarketingContent(this.props.giftlistMarketingContent)  : this.props.giftlistMarketingContent} 
                      store={this.props} 
                       downloadPdfData={{
                        handlePDFDownload: this.handleRegistradosWapPDFDownload,
                        selectedTheme: this.state.selectedTheme || this.defaultTheme || {},
                        lables: this.props.lables,
                        selectedTab: this.selectedTab,
                        isDisable: this.anadirRegalosDivEnable(),
                        eventChecklistPdfUrl: this.props.eventCategory?.eventConfigurations?.find(eventConfig => eventConfig.name === this.props.eventType)?.event_checklist_pdf_url?.href || "",
                      }}
                    />
                 </div>
              </div>
            </div>
              {/* <div className="addGiftOptions visibleContent side-bar-menu" style={style}>
                <div className="addGiftMenu">
                  <ul>
                    {linkJSON.map((link, id) => (
                      <li key={id + 'events'}>
                        {id === 0 || id === 2 || (commonUtil.getBrand() !== defaultConst.constBrand.LP) ?
                          <Link linkJSON={link}>
                            {link.displayName}
                            <i className="icon-flecha_lightsvg_derecha" />
                          </Link>
                          :
                          <Link rrLink={link}>
                            {link.displayName}
                            <i className="icon-flecha_lightsvg_derecha" />
                          </Link>
                        }
                      </li>
                    ))}
                  </ul>
                </div>
              </div> */}
            </div>

              <div className="row giftlist-wap-carousel-section">
                  <div className="col-xs-12">
                    <MarketingContentSection contentSection={this.props.giftlistFooterMarketingContent} store={this.props} />
                  </div>
              </div>

            <ModalPopover
              headerData={shareModalHeaderData}
              dismiss="false"
              isModal="true"
              modalId="sharingModal"
              ref={(ref) => {
                if (_.isNil(this.state.shareModal.wap)) {
                  this.setState({ shareModal: { wap: ref } });
                }
              }}
            >
            <hr className="divider" />
              <div className="row">
                <div className="col-xs-12">
                  <FacebookProvider appId={facebookAppID}>
                    <ShareButton
                      href={socialSharePath}
                      className="btn btn-labeled btn-primary center-block"
                      iconClassName=""
                      icon=""
                      type="button"
                    >
                      <span className="btn-label">
                        <i className="iClass icon-social-facebook" />
                      </span>
                      <p className="btn-txt pt10">
                        {commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          'adminpage.regalosregistrados.socialshare.facebook.label',
                        )}
                      </p>
                    </ShareButton>
                  </FacebookProvider>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <a href={`https://twitter.com/intent/tweet?url=${socialSharePath}&via=${brandName}`} target="popup">
                    <button className="btn btn-labeled btn-info center-block" type="button">
                      <span className="btn-label">
                        <i className="iClass icon-social-twitter" />
                      </span>
                      <p className="btn-txt pt10">
                        {commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          'adminpage.regalosregistrados.socialshare.twitter.label',
                        )}
                      </p>
                    </button>
                  </a>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <a href={`whatsapp://send?text=${socialSharePath}`} data-action="share/whatsapp/share">
                    <button className="btn btn-labeled btn-success center-block" type="button">
                      <span className="btn-label">
                        <i className="iClass icon-social-whatsapp" />
                      </span>
                      <p className="btn-txt pt10">
                        {commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          'adminpage.regalosregistrados.socialshare.whatsapp.label',
                        )}
                      </p>
                    </button>
                  </a>
                </div>
              </div>
            </ModalPopover>
          </>}
          <>
            {this.state.activeBar !== 'mesa-de-regalos' &&
              <>
                {
                  this.state.activeBar === "datos-personales" &&
                  <div className="data-personales-container">
                    <PersonalData
                      //  eventId={'72000127'}
                      //  profileId={'2431030002'}
                      eventStatusInfo={this.props.eventStatusInfo || ''}
                      eventId={this.eventId}
                      profileId={this.props.user.result.profileId}
                      user={this.props.user}
                      //  user={this.props.user}
                      eventType={this.props.eventType}
                      selectedTheme ={this.state.selectedTheme || {}}
                    />
                  </div>
                }
                {
                  this.state.activeBar === "direcciones-de-entrega" &&
                  <div>
                    <DeliveryAddress
                      // eventId={'560035'}
                      // profileId={'9945536225'} 
                      eventId={this.eventId}
                      user={this.props.user}
                      backtoMainHandler={this.backtoMainHandler}
                      selectedTheme ={this.state.selectedTheme || {}}
                      showMessagePopUp={this.showMessagePopUp}  
                      eventStatusInfo={this.props.eventStatusInfo || ''}
                    />
                  </div>
                }
                {this.state.activeBar === "personalizacion" && (
                  <Personalization
                    // eventID={'560035'}
                    eventID={this.eventId}
                    lables={this.props.lables}
                    eventType={this.props.eventType}
                    user={this.props.user}
                    // profileId={'9945536225'}
                    profileId={this.props.user.result.profileId}
                    userEventDetails={this.props.userEventDetails}
                    getEventDetails={this.props.getEventDetails}
                    eventcategory={this.props.eventCategory}
                    onActiveThemeColorUpdate={this.onActiveThemeColorUpdate}
                    onBackClick={() => { this.onItemClick(0, true) }}
                    showMessagePopUp={this.showMessagePopUp}
                    selectedTheme ={this.state.selectedTheme || {}}
                    eventStatusInfo={this.props.eventStatusInfo || ''}
                  />
                )}
                {this.state.activeBar === "contrato" && (
                  <ContractEM eventID={this.eventId} lables={this.props.lables} userEventDetails={this.props.userEventDetails} onBackClick={() => { this.onItemClick(0, true) }} selectedTheme ={this.state.selectedTheme || {}}/>
                )}

                {this.state.activeBar === "regalo-del-evento" && (
                  <EventGiftModalOverlay
                    hideModalOverlay={() => { this.onItemClick(0,false,true)}}
                    getEventThresholdGiftDetails={this.props.getEventThresholdGiftDetails}
                    getPurchaseInfoDetails={this.props.getPurchaseInfoDetails}
                    userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails}
                    purchaseInfoDetails={this.props.purchaseInfoDetails}
                    userEventDetails={this.props.userEventDetails}
                    deliveryAddress={this.props.deliveryAddress}
                    selectedTheme={this.state.selectedTheme || {}}
                    lables={this.props.lables}
                    eventInfo={this.props?.giftList?.eventSummaryInfo?.eventInfo || {}}
                  />
                )}

                {this.state.activeBar === "mi-id-mesa-de-regalos" && (
                  <GiftRegistryIdModalOverlay
                    hideModalOverlay={() => { this.onItemClick(0,false,true) }}
                    eventID={this.eventId}
                    ecardId={this.props.ecardId}
                  />
                )}

                {this.state.activeBar === "crear-mesa" && (
                  <CreateTableModalOverlay
                    hideModalOverlay={() => { this.onItemClick(0,false,true) }}
                    allowedEventTypes={this.props.allowedEventTypes}
                    selectedTheme ={this.state.selectedTheme || {}} 
                  />
                )}

                {this.state.activeBar == "chat-message-modal" && (
                  <ChatMessageWap 
                    handleChatBackModalOverlay={() => this.handleChatBackModalOverlay(false)}
                    selectedProduct={this.state.displayRegalosSelectedProductDetailWap}
                    compareEventStatus={this.compareEventStatus}
                    eventId={this.eventId} 
                    lables={this.props.lables}
                    sortingValue={this.state.sortingValue}
                    filterParameter={this.state.filterParam}
                    getRecievedGiftList={this.getRecievedGiftList}
                    receivedGiftList={receivedGiftList}
                  />
                )}
              </>
            }
          </>

        </React.Fragment> :
          <div>
            {this.state.giftSectionType === 'ComprasPersonales' ?
              <ProductDetails selectedProduct={this.state.displaySelectedProductDetail} compareEventStatus={this.compareEventStatus} eventId={this.eventId} lables={this.props.lables} />
              :
              <ProductDetailsRecibidos
                selectedProduct={this.state.displaySelectedProductDetail}
                compareEventStatus={this.compareEventStatus}
                eventId={this.eventId} lables={this.props.lables}
                sortingValue={this.state.sortingValue}
                filterParameter={this.state.filterParam}
                getRecievedGiftList={this.getRecievedGiftList}
              />
            }
              <div class="row giftlist-web-carousel-section">
                <div className="col-xs-12">
                     <MarketingContentSection contentSection={this.props.giftlistFooterMarketingContent} store={this.props} />
                  </div>
              </div>
          </div>
      );
    }
    return null;
  }

  render() {
    return (
      <React.Fragment>
        <ApplyCSS pageName="giftList" />
        <Tagging ref={tagging => this.tagging = tagging} />
        {channel === constChannels.WAP ? this.renderWap() : this.renderWeb()}
        <VozCliente page="mesa" />
      </React.Fragment>
    );
  }

}

const mapStateToProps = state => ({
  lables: state.labels.data,
  loadingReceivedGifts: state.giftList.loadingReceivedGifts,
  loadingPersonalGifts: state.giftList.loadingPersonalGifts,
  loadingRegisteredGifts: state.giftList.loadingRegisteredGifts,
  loadingAllRegisteredGifts: state.giftList.loadingAllRegisteredGifts,
  giftList: state.giftList.data,
  showThankyouPopUp: state.contractPage.showThankyouPopUp,

  eventStatusInfo: state.giftList &&
    state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.eventStatus,

  eventSummaryInfoHeader: state.giftList &&
    state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.predeterminedListIdExists,

  eventType: state.giftList && state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.eventType,


  suggestionLink: state.giftList && state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.suggestionLink,

  predeterminedListId: state.giftList && state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.predeterminedListIdExists,
  eventDetails: state.eventDetail.data,

  notifificationCount: state.giftList.notificationCount,

  userEventDetails: state.giftList.userEventDetails,
  userEventThresholdGiftDetails: state.giftList.userEventThresholdGiftDetails,
  purchaseInfoDetails: state.giftList.purchaseInfoDetails,

  deliveryAddress: state.deliveryAddress.data,

  ecardId: state?.eCardDetails?.data?.ecardId || '',
  giftlistMarketingContent: state?.giftList?.data?.giftlistMarketingContent,
  giftlistFooterMarketingContent: state?.giftList?.data?.giftlistFooterMarketingContent,

  accountStatus: state.accountSummary && state.accountSummary.accountStatus,
  intransitData: state.accountSummary && state.accountSummary.intransit,
  statementDetailsForPrintAndDownloadData: state.accountSummary && state.accountSummary.statementDetailsForPrintAndDownloadData,

});

const matchDispatchToProps = dispatch => bindActionCreators(
  {
    getReceivedGiftList,
    getRegisteredGiftList,
    getPersonalShoppingList,
    setPageFlag,
    setNotificationCount,
    getEventSummaryInfo,
    getEventDetails,
    getEventThresholdGiftDetails,
    getPurchaseInfoDetails,
    getDeliveryAddressInfo,
    handleGetEventCardDetails,
    getGiftlistMarketingContent,
    getGiftlistFooterMarketingContent,
    getEventAccountStatementDetails, 
    getInTransitDetails, 
    getStatementDetailsForPrintAndDownload,
    resetStore,
  }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(GiftList);
